<template>
  <div class="action">
    <!--button @click="isOpen = !isOpen" class="button is-primary" slot="botton">
      Update User
    </button-->
    <div :class="['modal', { 'is-active': isOpen }]">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Update Client</p>
          <button @click="cancel" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <form>
            <div class="columns">
              <div class="column">
                <div class="field">
                      <label class="modal-card-title">Name (Nepali)</label>
                      <input
                        v-model="form.nepali_name"
                        @blur="$v.form.nepali_name.$touch"
                        type="text"
                        class="input"
                        placeholder="Name (Nepali)"
                        v-on:keyup="convertName"
                      />
                </div>
                <div class="field">
                    <label class="modal-card-title">Name (English)</label>
                    <input
                    v-model="form.english_name"
                    @blur="$v.form.english_name.$touch"
                    type="text"
                    class="input"
                    placeholder="Name (English)"
                    />
                </div>


                <div class="field">
                    <label class="modal-card-title">Gender</label><p>
                    <!-- <input
                    v-model="form.gender"
                    @blur="$v.form.gender.$touch"
                    type="text"
                    class="input"
                    placeholder="Gender"
                    /> -->
                     <input class="radio" type="radio" v-model="form.gender" @blur="$v.form.gender.$touch" value="पुरुष">पुरुष
                    <span style="margin-right:40px;"></span>
                    <input class="radio" type="radio" v-model="form.gender" @blur="$v.form.gender.$touch" value="महिला">महिला
                    <span style="margin-right:40px;"></span>
                    <input class="radio" type="radio" v-model="form.gender" @blur="$v.form.gender.$touch" value="अन्य">अन्य
            </p>
                </div>

                <div class="field">
                    <label class="modal-card-title">DOB
                      <template v-if="birthDateSwitch_1 == 1">
                        <button type="button" @click='changeDateSelection("birthDateSwitch_1")'>In BS</button>
                      </template>
                      <template v-else>
                        <button type="button" @click='changeDateSelection("birthDateSwitch_1")'>In AD</button>
                      </template>
                    </label>
                    <p class="control">
                    <template v-if="birthDateSwitch_1 == 1">
                      <date-picker v-model="form.birth_date_eng" valueType="format" @blur="$v.form.birth_date_eng.$touch"
                      @input ="assignDates($event, 'birth_date', 'birth_date_eng', 1)"
                      ></date-picker>
                    </template>
                    <template v-else> 
                      <VNepaliDatePicker 
                          classValue="datepicker"
                          placeholder="YYYY-MM-DD"
                          type="date" 
                          v-model="form.birth_date"
                          @blur="$v.form.birth_date.$touch"
                          autocomplete="birth_date"
                          @change="assignDates($event, 'birth_date', 'birth_date_eng', 0)"
                      />
                    </template>
                    </p>
                </div>

                <div class="field">
                  <label class="modal-card-title">Citizenship No.</label>
                  <input
                    v-model="form.citizenship_number"
                    @blur="$v.form.citizenship_number.$touch"
                    type="text"
                    class="input"
                    placeholder="Citizenship No."
                    @keypress="isLetterOrNumber($event)"
                    v-on:keyup="convertCitizen($event)"
                  />
                </div>

                <div class="field">
                  <label class="modal-card-title">नागरिकता जारी मिति
                    <template v-if="citizenDateSwitch_1 == 1">
                      <button type="button" @click='changeDateSelection("citizenDateSwitch_1")'>In BS</button>
                    </template>
                    <template v-else>
                      <button type="button" @click='changeDateSelection("citizenDateSwitch_1")'>In AD</button>
                    </template>
                  </label>
                  <p class="control">
                    <template v-if="citizenDateSwitch_1 == 1">
                      <date-picker v-model="form.citizenship_date_eng" valueType="format" @blur="$v.form.citizenship_date_eng.$touch"
                      @input ="assignDates($event, 'citizenship_date', 'citizenship_date_eng', 1)"
                      ></date-picker>
                    </template>
                    <template v-else>
                      <VNepaliDatePicker 
                        classValue="datepicker"
                        placeholder="YYYY-MM-DD"
                        type="date" 
                        v-model="form.citizenship_date"
                        @blur="$v.form.citizenship_date.$touch"
                        autocomplete="citizenship_date"
                        @change="assignDates($event, 'citizenship_date', 'citizenship_date_eng', 0)"
                      />
                    </template>
                  </p>

                  <div v-if="$v.form.citizenship_date.$error || $v.form.citizenship_date_eng.$error" class="form-error">
                    <span v-if="!$v.form.citizenship_date.required || !$v.form.citizenship_date_eng.required" class="help is-danger">Citizenship Date is required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">बुवाको नाम</label>
                  <input
                    v-model="form.father_name"
                    @blur="$v.form.father_name.$touch"
                    type="text"
                    class="input"
                    placeholder="Father's Name"
                    v-on:keyup="convertFatherName"
                  />

                  <div v-if="$v.form.father_name.$error" class="form-error">
                    <span v-if="!$v.form.father_name.required" class="help is-danger">Father's Name is Required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">हजुरबुवाको नाम</label>
                  <input
                    v-model="form.grandfather_name"
                    @blur="$v.form.grandfather_name.$touch"
                    type="text"
                    class="input"
                    placeholder="Grandfather's Name"
                    v-on:keyup="convertGrandfatherName"
                   />
                  <div v-if="$v.form.grandfather_name.$error" class="form-error">
                    <span v-if="!$v.form.grandfather_name.required" class="help is-danger">Grandfather Name is Required</span>
                  </div>
                </div>

                 <div class="field">
                  <label class="modal-card-title">Mobile No.</label>
                  <input
                    v-model="form.mobile_number"
                    @blur="$v.form.mobile_number.$touch"
                    type="text"
                    class="input"
                    placeholder="Mobile No."
                  />

                  <div v-if="$v.form.mobile_number.$error" class="form-error">
                    <span v-if="!$v.form.mobile_number.required" class="help is-danger">Mobile Number is Required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">Phone No.</label>
                  <input
                    v-model="form.phone_number"
                    @blur="$v.form.phone_number.$touch"
                    type="text"
                    class="input"
                    placeholder="Phone No."
                  />

                  <div v-if="$v.form.phone_number.$error" class="form-error">
                    <span v-if="!$v.form.phone_number.required" class="help is-danger">Phone Number is Required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">District</label>
                    <!-- <input
                    v-model="form.district"
                    @blur="$v.form.district.$touch"
                    type="text"
                    class="input"
                    placeholder="District"
                    /> -->
                  <Dropdown
                    :options="districtList"
                    v-on:selected="districtSelection"
                    :disabled="false"
                    name="unique-input11"
                    :maxItem="62"
                     v-model="form.district"
                    placeholder="Select your District">
                  </Dropdown>

                  <div v-if="$v.form.district.$error" class="form-error">
                    <span v-if="!$v.form.district.required" class="help is-danger">District is Required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">न.पा./गा.वि.स. </label>
                  <input 
                    class="input"
                    v-model="form.municipality"
                    @blur="$v.form.municipality.$touch"
                    placeholder="Enter your municipality"
                    autocomplete="municipality"
                    v-on:keyup="convertNepali('municipality')"
                  >
              
                  <div v-if="$v.form.municipality.$error" class="form-error">
                    <span v-if="!$v.form.municipality.required" class="help is-danger">Municipality is Required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">Municipality/V.D.C </label>
                  <Dropdown
                    :options="municipalityOptions"
                    v-on:selected="municipalitySelection"
                    :disabled="false"
                    name="unique-input11"
                    :maxItem="62"
                    placeholder="Select your Municipality">
                  </Dropdown>
                  <div v-if="$v.form.municipality.$error" class="form-error">
                    <span v-if="!$v.form.municipality.required" class="help is-danger">Municipality is Required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">Ward</label>
                  <Dropdown
                    :options="wardList"
                    v-on:selected="wardSelection"
                    :disabled="false"
                    name="unique-input25"
                    :maxItem="62"
                    placeholder="Select your Ward">
                  </Dropdown>

                  <div v-if="$v.form.ward.$error" class="form-error">
                    <span v-if="!$v.form.ward.required" class="help is-danger">Ward is Required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">स्थाई ठेगाना</label>
                  <input
                    v-model="form.permanent_address"
                    @blur="$v.form.permanent_address.$touch"
                    type="text"
                    class="input"
                    placeholder="Permanent Address"
                    v-on:keyup="convertNepali('permanent_address')"
                  />
                  <div v-if="$v.form.permanent_address.$error" class="form-error">
                    <span v-if="!$v.form.permanent_address.required" class="help is-danger">Permanent Address is Required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">Permanent Address</label>
                  <input
                    v-model="form.permanent_address_eng"
                    @blur="$v.form.permanent_address_eng.$touch"
                    type="text"
                    class="input"
                    placeholder="Permanent Address"
                  />

                  <div v-if="$v.form.permanent_address_eng.$error" class="form-error">
                    <span v-if="!$v.form.permanent_address_eng.required" class="help is-danger">Permanent Address is Required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">हालको ठेगाना</label>
                  <input
                    v-model="form.current_address"
                    @blur="$v.form.current_address.$touch"
                    type="text"
                    class="input"
                    placeholder="Current Address"
                    v-on:keyup="convertNepali('current_address')"
                  />
                  <div v-if="$v.form.current_address.$error" class="form-error">
                    <span v-if="!$v.form.current_address.required" class="help is-danger">Current Address is required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">Current Address</label>
                  <input
                    v-model="form.current_address_eng"
                    @blur="$v.form.current_address_eng.$touch"
                    type="text"
                    class="input"
                    placeholder="Current Address"
                  />
                  <div v-if="$v.form.current_address_eng.$error" class="form-error">
                    <span v-if="!$v.form.current_address_eng.required" class="help is-danger">Current Address is required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">अस्थायी ठेगाना</label>
                  <input
                    v-model="form.temporary_address"
                    @blur="$v.form.temporary_address.$touch"
                    type="text"
                    class="input"
                    placeholder="Temporary Address"
                    v-on:keyup="convertNepali('temporary_address')"
                  />
                  <div v-if="$v.form.temporary_address.$error" class="form-error">
                    <span v-if="!$v.form.temporary_address.required" class="help is-danger">Temporary Address is required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">Temporary Address</label>
                  <input
                    v-model="form.temporary_address_eng"
                    @blur="$v.form.temporary_address_eng.$touch"
                    type="text"
                    class="input"
                    placeholder="Temporary Address"
                  />
                  <div v-if="$v.form.temporary_address_eng.$error" class="form-error">
                    <span v-if="!$v.form.temporary_address_eng.required" class="help is-danger">Temporary Address is required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">Bank</label>
                    <!-- <input
                    v-model="form.bank"
                    @blur="$v.form.bank.$touch"
                    type="text"
                    class="input"
                    placeholder="Bank"
                    /> -->
                  <Dropdown
                    :options="bankValues"
                    v-on:selected="bankSelection"
                    :disabled="false"
                    name="unique-input11"
                    :maxItem="62"
                    placeholder="Select your bank">
                  </Dropdown>
                  <div v-if="$v.form.bank.$error" class="form-error">
                    <span v-if="!$v.form.bank.required" class="help is-danger">Bank is required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">Account No.</label>
                  <input
                    v-model="form.account_number"
                    @blur="$v.form.account_number.$touch"
                    type="text"
                    class="input"
                    placeholder="Account No."
                    @keypress="isLetterOrNumber($event)"
                    v-on:keyup="convertAccountNumber($event)"
                  />
                  <div v-if="$v.form.account_number.$error" class="form-error">
                    <span v-if="!$v.form.accoun_number.required" class="help is-danger">Account Number is Required</span>
                  </div>
                </div>

                <div class="field">
                    <label class="modal-card-title">लाभार्थीको नाम</label>
                    <input
                    v-model="form.beneficiary_name"
                    @blur="$v.form.beneficiary_name.$touch"
                    type="text"
                    class="input"
                    placeholder="Beneficiary Name"
                    v-on:keyup="convertNepali('beneficiary_name')"
                    />
                    <div v-if="$v.form.beneficiary_name.$error" class="form-error">
                      <span v-if="!$v.form.beneficiary_name.required" class="help is-danger">Beneficiary Name is required</span>
                    </div>
                </div>

                <div class="field">
                    <label class="modal-card-title">Beneficiary Name</label>
                    <input
                    v-model="form.beneficiary_name_eng"
                    @blur="$v.form.beneficiary_name_eng.$touch"
                    type="text"
                    class="input"
                    placeholder="Beneficiary Name"
                    />
                    <div v-if="$v.form.beneficiary_name_eng.$error" class="form-error">
                      <span v-if="!$v.form.beneficiary_name_eng.required" class="help is-danger">Beneficiary Name is required</span>
                    </div>
                </div>

                <div class="field">
                    <label class="modal-card-title">सम्बन्ध</label>
                    <!-- <input
                    v-model="form.relationship"
                    @blur="$v.form.relationship.$touch"
                    type="text"
                    class="input"
                    placeholder="Relationship"
                    /> -->
                    <Dropdown
                      :options="relationList"
                      v-on:selected="relationSelection"
                      :disabled="false"
                      name="unique-input11"
                      :maxItem="62"
                      placeholder="Select your relationship"
                      v-on:filter="getDropdownValues">
                    </Dropdown>
                    <div v-if="$v.form.relationship.$error" class="form-error">
                      <span v-if="!$v.form.relationship.required" class="help is-danger">Relationship is required</span>
                     </div>
                </div>

                <div class="field">
                    <label class="modal-card-title">लाभार्थीको सम्पर्क नम्बर</label>
                    <input
                    v-model="form.beneficiary_contact"
                    @blur="$v.form.beneficiary_contact.$touch"
                    type="text"
                    class="input"
                    placeholder="Beneficiary Contact"
                    />
                    <div v-if="$v.form.beneficiary_contact.$error" class="form-error">
                      <span v-if="!$v.form.beneficiary_contact.required" class="help is-danger">Beneficiary Contact is Required</span>
                    </div>
                </div>

                <div class="field">
                    <label class="modal-card-title">लाभार्थीको ठेगाना</label>
                    <input
                    v-model="form.beneficiary_address"
                    @blur="$v.form.beneficiary_address.$touch"
                    type="text"
                    class="input"
                    placeholder="Beneficiary Address"
                    />
                    <div v-if="$v.form.beneficiary_address.$error" class="form-error">
                      <span v-if="!$v.form.beneficiary_address.required" class="help is-danger">Beneficiary Address is required</span>
                    </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">दर्ता मिति
                    <template v-if="registrationDateSwitch_1 == 1">
                      <button type="button" @click='changeDateSelection("registrationDateSwitch_1")'>In BS</button>
                    </template>
                    <template v-else>
                      <button type="button" @click='changeDateSelection("registrationDateSwitch_1")'>In AD</button>
                    </template>
                  </label>

                  <p class="control">
                  <template v-if="registrationDateSwitch_1 == 1">
                    <date-picker v-model="form.registration_date_eng" valueType="format" @blur="$v.form.registration_date_eng.$touch"
                    @input ="assignDates($event, 'registration_date', 'registration_date_eng', 1)"
                    ></date-picker>
                  </template>
                  <template v-else>
                    <VNepaliDatePicker 
                      classValue="datepicker"
                      placeholder="YYYY-MM-DD"
                      type="date" 
                      v-model="form.registration_date"
                      @blur="$v.form.registration_date.$touch"
                      autocomplete="registration_date"
                      @change="assignDates($event, 'registration_date', 'registration_date_eng', 0)"
                    />
                  </template>
                  </p>

                  <div v-if="$v.form.registration_date.$error || $v.form.registration_date_eng.$error" class="form-error">
                    <span v-if="!$v.form.registration_date.required || !$v.form.registration_date_eng.required" class="help is-danger">Registration Date is required</span>
                  </div>
                </div>

                 <div class="field">
                    <label class="modal-card-title">परिचयकर्ता </label>
                    <input
                    v-model="form.referred_by"
                    @blur="$v.form.referred_by.$touch"
                    type="text"
                    class="input"
                    placeholder="Referred By"
                    v-on:keyup="convertNepali('referred_by')"
                    />
                    <div v-if="$v.form.referred_by.$error" class="form-error">
                      <span v-if="!$v.form.referred_by.required" class="help is-danger">Referred By is required</span>
                    </div>
                </div>

                <div class="field">
                    <label class="modal-card-title">Referred By</label>
                    <input
                    v-model="form.referred_by_eng"
                    @blur="$v.form.referred_by_eng.$touch"
                    type="text"
                    class="input"
                    placeholder="Referred By"
                    />
                    <div v-if="$v.form.referred_by_eng.$error" class="form-error">
                      <span v-if="!$v.form.referred_by_eng.required" class="help is-danger">Referred By is required</span>
                    </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">भौचर दिपोशीत मिति
                    <template v-if="voucherDateSwitch_1 == 1">
                      <button type="button" @click='changeDateSelection("voucherDateSwitch_1")'>In BS</button>
                    </template>
                    <template v-else>
                      <button type="button" @click='changeDateSelection("voucherDateSwitch_1")'>In AD</button>
                    </template>
                  </label>
                  <p class="control">
                  <template v-if="voucherDateSwitch_1 == 1">
                    <date-picker v-model="form.voucher_deposit_date_eng" valueType="format" @blur="$v.form.voucher_deposit_date_eng.$touch"
                    @input ="assignDates($event, 'voucher_deposit_date', 'voucher_deposit_date_eng', 1)"
                    ></date-picker>
                  </template>
                  <template v-else>
                    <VNepaliDatePicker 
                      classValue="datepicker"
                      placeholder="YYYY-MM-DD"
                      type="date" 
                      v-model="form.voucher_deposit_date"
                      @blur="$v.form.voucher_deposit_date.$touch"
                      autocomplete="voucher_deposit_date"
                      @change="assignDates($event, 'voucher_deposit_date', 'voucher_deposit_date_eng', 0)"
                    />
                  </template>
                  </p>

                  <div v-if="$v.form.voucher_deposit_date.$error || $v.form.voucher_deposit_date_eng.$error" class="form-error">
                    <span v-if="!$v.form.voucher_deposit_date.required || !$v.form.voucher_deposit_date_eng.required" class="help is-danger">Voucher Deposit Date is required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">रसिद न. </label>
                  <input
                    v-model="form.receipt_no"
                    @blur="$v.form.receipt_no.$touch"
                    type="text"
                    class="input"
                    placeholder="Receipt Number"
                  />
                  <div v-if="$v.form.receipt_no.$error" class="form-error">
                    <span v-if="!$v.form.receipt_no.required" class="help is-danger">Receipt Number is required</span>
                  </div>
                </div>

                <div class="field">
                  <label class="modal-card-title">रसिद मिति
                    <template v-if="receiptDateSwitch_1 == 1">
                      <button type="button" @click='changeDateSelection("receiptDateSwitch_1")'>In BS</button>
                    </template>
                    <template v-else>
                      <button type="button" @click='changeDateSelection("receiptDateSwitch_1")'>In AD</button>
                    </template>
                  </label>
                  <p class="control">
                  <template v-if="receiptDateSwitch_1 == 1">
                    <date-picker v-model="form.receipt_date_eng" valueType="format" @blur="$v.form.receipt_date_eng.$touch"
                    @input ="assignDates($event, 'receipt_date', 'receipt_date_eng', 1)"
                    ></date-picker>
                  </template>
                  <template v-else>
                    <VNepaliDatePicker 
                      classValue="datepicker"
                      placeholder="YYYY-MM-DD"
                      type="date" 
                      v-model="form.receipt_date"
                      @blur="$v.form.receipt_date.$touch"
                      autocomplete="receipt_date"
                      @change="assignDates($event, 'receipt_date', 'receipt_date_eng', 0)"
                    />
                  </template>
                  </p>

                  <div v-if="$v.form.receipt_date.$error || $v.form.receipt_date_eng.$error" class="form-error">
                    <span v-if="!$v.form.receipt_date.required || !$v.form.receipt_date_eng.required" class="help is-danger">Registration Date is required</span>
                  </div>
                </div>

                <div class="field">
                    <label class="modal-card-title">Form Date (Page 1)</label>
                    <VNepaliDatePicker 
                        classValue="datepicker"
                        placeholder="YYYY-MM-DD"
                        type="date" 
                        v-model="form.form_date_one"
                        @blur="$v.form.form_date_one.$touch"
                        autocomplete="form_date_one"
                        :key="formDateOneComponentKey"
                    />
                    <div @click="clearFormDateOne" class="button">Clear</div>
                </div>

                <div class="field">
                    <label class="modal-card-title">Form Date (Page 2)</label>
                    <VNepaliDatePicker 
                        classValue="datepicker"
                        placeholder="YYYY-MM-DD"
                        type="date" 
                        v-model="form.form_date"
                        @blur="$v.form.form_date.$touch"
                        autocomplete="form_date"
                        :key="formDateComponentKey" 
                    />
                    <div @click="clearFormDate" class="button">Clear</div>
                </div>

                <!-- <div class="field">
                    <label class="modal-card-title">Card Status</label><p>
                     <input class="radio" type="radio" v-model="form.card_status" @blur="$v.form.card_status.$touch" value="Yes">Yes
                    <span style="margin-right:40px;"></span>
                    <input class="radio" type="radio" v-model="form.card_status" @blur="$v.form.card_status.$touch" value="No">No
            </p>
                </div> -->

                  <div class="columns is-multiline">
                    <div class="column is-half">
                      <label>Form</label>
                            <b-field class="field">
                              <b-upload :rules="rules" v-model="formScan" @input="uploadForm" id="upload_file" accept="image/*">
                                <a class="button is-primary">
                                  <b-icon icon="upload" custom-size="default"></b-icon>
                                  <span>{{ formScanLabel }}</span>
                                </a>
                              </b-upload>
                              <!-- <span class="file-name" v-if="formScan">{{ formScan.name }}</span> -->
                            </b-field>
                            <div v-if="$v.form.form_scan.$error" class="form-error">
                                      <span v-if="!$v.form.form_scan.required" class="help is-danger">Form Error</span>
                                    </div>
                          <span class="file-name" v-if="formScan">{{ formScan.name }}</span>
                    </div>
                        <div class="column is-half">
                          <label>Photo</label>
                            <b-field class="field">
                              <b-upload v-model="photoScan" @input="uploadPhoto" accept="image/png, image/jpeg, image/bmp">
                                <a class="button is-primary">
                                  <b-icon icon="upload" custom-size="default"></b-icon>
                                  <span>{{ photoScanLabel }}</span>
                                </a>
                              </b-upload>
                            </b-field>

                            <div v-if="$v.form.photo_scan.$error" class="form-error">
                                      <span v-if="!$v.form.photo_scan.required" class="help is-danger">Photo Error</span>
                                    </div>

                            <!-- <progress
                              v-if="uploadPercent > 0"
                              class="progress is-primary"
                              :value="uploadPercent"
                              max="100"
                            >{{uploadPercent}}%</progress> -->
                                            <span class="file-name" v-if="photoScan">{{ photoScan.name }}</span>

                    </div>
                  </div>
                  <div class="columns is-multiline">
                            <div class="column is-half">
                          <label>Citizzenship Front</label>
                            <b-field>
                              <b-upload v-model="citizenshipScan1" @input="uploadCitizenship1" accept="image/*">
                                <a class="button is-primary">
                                  <b-icon icon="upload" custom-size="default"></b-icon>
                                  <span>{{ formCitizenshipLabel1 }}</span>
                                </a>
                              </b-upload>
                            </b-field>
                                    <div v-if="$v.form.citizenship_scan_front.$error" class="form-error">
                                      <span v-if="!$v.form.citizenship_scan_front.required" class="help is-danger">Photo Error</span>
                                    </div>
                                      <span class="file-name" v-if="citizenshipScan1">{{ citizenshipScan1.name }}</span>


                            </div>
                            <div class="column is-half">
                              <label>Citizenship Back</label>
                            <b-field class="field">
                              <b-upload v-model="citizenshipScan2" @input="uploadCitizenship2" accept="image/*">
                                <a class="button is-primary">
                                  <b-icon icon="upload" custom-size="default"></b-icon>
                                  <span>{{ formCitizenshipLabel2 }}</span>
                                </a>
                              </b-upload>
                            </b-field>

                            <div v-if="$v.form.citizenship_scan_back.$error" class="form-error">
                                      <span v-if="!$v.form.citizenship_scan_back.required" class="help is-danger">Photo Error</span>
                                    </div>
                                              <span class="file-name" v-if="citizenshipScan2">{{ citizenshipScan2.name }}</span>

                            </div>
                      </div>
                        <div class="columns is-multiline">
                            <div class="column is-half">
                              <label>Voucher</label>
                            <b-field class="field">
                              <b-upload v-model="voucherScan" @input="uploadVoucher" accept="image/*">
                                <a class="button is-primary">
                                  <b-icon icon="upload" custom-size="default"></b-icon>
                                  <span>{{ formVoucherLabel }}</span>
                                </a>
                              </b-upload>
                            </b-field>
                            <div v-if="$v.form.voucher_scan.$error" class="form-error">
                                      <span v-if="!$v.form.voucher_scan.required" class="help is-danger">Photo Error</span>
                                    </div>
                                              <span class="file-name" v-if="voucherScan">{{ voucherScan.name }}</span>


                            <!-- <progress
                              v-if="uploadPercent > 0"
                              class="progress is-primary"
                              :value="uploadPercent"
                              max="100"
                            >{{uploadPercent}}%</progress> -->
                    </div>
                          <div class="column is-half">
                            <label>Beneficiary</label>
                            <b-field class="field">
                              <b-upload v-model="hakwalaScan" @input="uploadHakwala" accept="image/*">
                                <a class="button is-primary">
                                  <b-icon icon="upload" custom-size="default"></b-icon>
                                  <span>{{ formHakwalaLabel }}</span>
                                </a>
                              </b-upload>
                            </b-field>
                            <div v-if="$v.form.hakwala_scan.$error" class="form-error">
                                      <span v-if="!$v.form.hakwala_scan.required" class="help is-danger">Photo Error</span>
                                    </div>
                                              <span class="file-name" v-if="hakwalaScan">{{ hakwalaScan.name }}</span>


                            <!-- <progress
                              v-if="uploadPercent > 0"
                              class="progress is-primary"
                              :value="uploadPercent"
                              max="100"
                            >{{uploadPercent}}%</progress> -->
                    </div>
                        </div>
                        <div class="columns is-multiline">
                          <div class="column is-half">
                            <label>Fingerprint Left</label>
                            <b-field class="field">
                              <b-upload v-model="fingerprintScan1" @input="uploadFingerprint1" accept="image/*">
                                <a class="button is-primary">
                                  <b-icon icon="upload" custom-size="default"></b-icon>
                                  <span>{{ formFingerprintLabel1 }}</span>
                                </a>
                              </b-upload>
                            </b-field>
                            <div v-if="$v.form.fingerprint_left.$error" class="form-error">
                                      <span v-if="!$v.form.fingerprint_left.required" class="help is-danger">Photo Error</span>
                                    </div>
                                              <span class="file-name" v-if="fingerprintScan1">{{ fingerprintScan1.name }}</span>

                    <!-- 
                            <progress
                              v-if="uploadPercent > 0"
                              class="progress is-primary"
                              :value="uploadPercent"
                              max="100"
                            >{{uploadPercent}}%</progress> -->
                          </div>
                          <div class="column is-half">
                            <label>Fingerprint Right</label>
                            <b-field class="field">
                              <b-upload v-model="fingerprintScan2" @input="uploadFingerprint2" accept="image/*">
                                <a class="button is-primary">
                                  <b-icon icon="upload" custom-size="default"></b-icon>
                                  <span>{{ formFingerprintLabel2 }}</span>
                                </a>
                              </b-upload>
                            </b-field>
                            <div v-if="$v.form.fingerprint_right.$error" class="form-error">
                                      <span v-if="!$v.form.fingerprint_right.required" class="help is-danger">Photo Error</span>
                                    </div>
                                              <span class="file-name" v-if="fingerprintScan2">{{ fingerprintScan2.name }}</span>

                            <!-- <progress
                              v-if="uploadPercent > 0"
                              class="progress is-primary"
                              :value="uploadPercent"
                              max="100"
                            >{{uploadPercent}}%</progress> -->
                    </div>
                        </div>
                        <div class="columns is-multiline">
                          <div class="column is-half">
                            <label>हस्ताक्षर</label>
                          <b-field class="field">
                            <b-upload v-model="signatureScan" @input="uploadSignature" accept="image/*">
                              <a class="button is-primary">
                                <b-icon icon="upload" custom-size="default"></b-icon>
                                <span>{{ formSignatureLabel }}</span>
                              </a>
                            </b-upload>
                          </b-field>
                          <div v-if="$v.form.signature_scan.$error" class="form-error">
                                    <span v-if="!$v.form.signature_scan.required" class="help is-danger">Signature is Required</span>
                                  </div>
                                            <span class="file-name" v-if="signatureScan">{{ signatureScan.name }}</span>


                          <!-- <progress
                            v-if="uploadPercent > 0"
                            class="progress is-primary"
                            :value="uploadPercent"
                            max="100"
                          >{{uploadPercent}}%</progress> -->
                          </div>
       
                        </div>

                <!-- <div class="field">
                    <label class="modal-card-title">Form Status</label><p>
                     <input class="radio" type="radio" v-model="form.form_status" @blur="$v.form.form_status.$touch" value="Yes">Complete
                    <span style="margin-right:40px;"></span>
                    <input class="radio" type="radio" v-model="form.form_status" @blur="$v.form.form_status.$touch" value="No">Incomplete
            </p>
                </div> -->

                <!-- <div class="field">
              <label class="modal-card-title">Question</label>
              <textarea v-model="form.question" class="textarea" placeholder="Enter question here..." />
            </div> -->
              <!-- <div class="field">
              <label class="modal-card-title m-b-sm">Please Choose User Role</label>
              <div class="control">
                <div class="select is-primary">
                  <select v-model="form.isVerified">
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
               
            </div>
                </div> -->
              </div>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot">
          <button
            @click="updateCitizenPressed"
            :disabled="isFormInvalid"
            class="button is-success"
          >
            Save changes
          </button>
          <button @click="cancel" class="button">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>



<script>
import axiosInstance from '../../services/axios';
import axios from 'axios';
import { getAPIEndpoint } from '../../helpers';
import { required, minLength, url, sameAs } from 'vuelidate/lib/validators';
import VNepaliDatePicker from 'v-nepalidatepicker';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Dropdown from 'vue-simple-search-dropdown';
import nepalify from 'nepalify';
import preeti2 from '../../helpers/preeti';
import NepaliDate from 'nepali-date-converter'
export default {
    components: {
      VNepaliDatePicker,
      Dropdown,
      DatePicker
    },
  data() {
    return {
      rules: [
      v => !!v || 'File is required',
      v => (v && v.length > 0) || 'File is required',
    ],
      name: '',
      slug: '',
      quantity: 0,
      formDateOneComponentKey: 0,
      formDateComponentKey: 0,
      // isOpen: false,
      isCategoryLoading: false,
      formScan: null,
      photoScan: null,
      citizenshipScan1: null,
      citizenshipScan2: null,
      voucherScan: null,
      hakwalaScan: null,
      fingerprintScan1: null,
      fingerprintScan2: null,
      signatureScan: null,
      birthDateSwitch_1: 0,
      citizenDateSwitch_1: 0,
      registrationDateSwitch_1: 0,
      voucherDateSwitch_1: 0,
      receiptDateSwitch_1:0,
      form: {
        // verification_token: this.selectedCitizen.verification_token,
        // verifiedBy: this.selectedCitizen.verifiedBy,
        // isVerified: this.selectedCitizen.isVerified,
        _id: this.selectedCitizen._id,

            nepali_name: this.selectedCitizen.full_name,
            english_name: this.selectedCitizen.english_name,
            gender: this.selectedCitizen.gender,
            citizenship_number: this.selectedCitizen.citizenship_number,
            birth_date: this.selectedCitizen.birth_date,
            birth_date_eng:this.selectedCitizen.birth_date_eng,
            father_name: this.selectedCitizen.father_name,
            grandfather_name: this.selectedCitizen.grandfather_name,
            district: this.selectedCitizen.district,
            district_eng: this.selectedCitizen.district_eng,
            mobile_number: this.selectedCitizen.mobile_number,
            phone_number: this.selectedCitizen.phone_number,
            permanent_address: this.selectedCitizen.permanent_address,
            permanent_address_eng:this.selectedCitizen.permanent_address_eng,
            current_address: this.selectedCitizen.current_address,
            current_address_eng:this.selectedCitizen.current_address_eng,
            temporary_address: this.selectedCitizen.temporary_address,
            temporary_address_eng:this.selectedCitizen.temporary_address_eng,
            bank: this.selectedCitizen.bank,
            account_number: this.selectedCitizen.account_number,
            beneficiary_name: this.selectedCitizen.beneficiary_name,
            beneficiary_name_eng:this.selectedCitizen.beneficiary_name_eng,
            relationship: this.selectedCitizen.relationship,
            beneficiary_contact: this.selectedCitizen.beneficiary_contact,
            registration_date:this.selectedCitizen.registration_date,
            registration_date_eng:this.selectedCitizen.registration_date_eng,
            referred_by: this.selectedCitizen.referred_by,
            referred_by_eng:this.selectedCitizen.referred_by_eng,
            citizenship_date:this.selectedCitizen.citizenship_date,
            citizenship_date_eng:this.selectedCitizen.citizenship_date_eng,
            beneficiary_address: this.selectedCitizen.beneficiary_address,
            voucher_deposit_date:this.selectedCitizen.voucher_deposit_date,
            voucher_deposit_date_eng:this.selectedCitizen.voucher_deposit_date_eng,
            receipt_no:this.selectedCitizen.receipt_no,
            receipt_date:this.selectedCitizen.receipt_date,
            receipt_date_eng:this.selectedCitizen.receipt_date_eng,
            municipality:this.selectedCitizen.municipality,
            municipality_eng:this.selectedCitizen.municipality_eng,
            form_status: this.selectedCitizen.form_status,
            ward_eng: this.selectedCitizen.ward_eng,
            ward: this.selectedCitizen.ward,
            // card_status: this.selectedCitizen.card_status,
            // entry_by: this.selectedCitizen.entry_by,
            // fingerprint_left: this.selectedCitizen.fingerprint_left,
            // fingerprint_right: this.selectedCitizen.fingerprint_right,
            // verifiedBy: this.selectedCitizen.verifiedBy,
            form_date: this.selectedCitizen.form_date,
            form_date_one: this.selectedCitizen.form_date_one,
            form_scan: this.selectedCitizen.form_scan,
            photo_scan: this.selectedCitizen.photo_scan,
            citizenship_scan_front: this.selectedCitizen.citizenship_scan_front,
            citizenship_scan_back: this.selectedCitizen.citizenship_scan_back,
            voucher_scan: this.selectedCitizen.voucher_scan,
            hakwala_scan: this.selectedCitizen.hakwala_scan,
            fingerprint_left: this.selectedCitizen.fingerprint_left,
            fingerprint_right: this.selectedCitizen.fingerprint_right,
            signature_scan: this.selectedCitizen.signature_scan,
            last_modified_by: this.$store.state.auth.user.name,
            last_modified: new Date(),
      },
      uploadPercent: 0,
      file: null,
      municipalityOptions:[],
      // bankValues: [{"id":1,"name":"Agriculture Development Bank Ltd."},{"id":2,"name":"Bank of Kathmandu Ltd."},{"id":3,"name":"Best Finance Ltd."},{"id":4,"name":"Capital Merchant Banking & Finance Ltd."},{"id":5,"name":"Central Finance Ltd."},{"id":6,"name":"Century Commercial Bank Ltd."},{"id":7,"name":"Citizens Bank International Ltd."},{"id":8,"name":"Civil Bank Ltd."},{"id":9,"name":"Corporate Development Bank Ltd."},{"id":10,"name":"Everest Bank Ltd."},{"id":11,"name":"Excel Development Bank Ltd."},{"id":12,"name":"Garima Bikas Bank Ltd."},{"id":13,"name":"Global IME Bank Ltd."},{"id":14,"name":"Goodwill Finance Ltd."},{"id":15,"name":"Gorkhas Finance Ltd."},{"id":16,"name":"Green Development Bank Ltd."},{"id":17,"name":"Guheshwori Merchant Banking & Finance Ltd."},{"id":18,"name":"Himalayan Bank Ltd."},{"id":19,"name":"ICFC Finance Ltd."},{"id":20,"name":"Janaki Finance Co. Ltd."},{"id":21,"name":"Jyoti Bikas Bank Ltd."},{"id":22,"name":"Kamana Sewa Bikas Bank Ltd."},{"id":23,"name":"Karnali Development Bank Ltd."},{"id":24,"name":"Kumari Bank Ltd."},{"id":25,"name":"Laxmi Bank Ltd."},{"id":26,"name":"Lumbini Bikash Bank Ltd."},{"id":27,"name":"Machhapuchhre Bank Ltd."},{"id":28,"name":"Mahalaxmi Development Bank Ltd."},{"id":29,"name":"Manjushree Finance Ltd."},{"id":30,"name":"Mega Bank Nepal Ltd."},{"id":31,"name":"Miteri Development Bank Ltd."},{"id":32,"name":"Muktinath Bikash Bank Ltd."},{"id":33,"name":"Multipurpose Finance Co. Ltd."},{"id":34,"name":"Nabil Bank Ltd."},{"id":35,"name":"Narayani Development Bank Ltd."},{"id":36,"name":"Nepal Bangladesh Bank Ltd."},{"id":37,"name":"Nepal Bank Ltd."},{"id":38,"name":"Nepal Credit & Commerce Bank Ltd."},{"id":39,"name":"Nepal Finance Ltd."},{"id":40,"name":"Nepal Investment Bank Ltd. "},{"id":41,"name":"Nepal SBI Bank Ltd."},{"id":42,"name":"Nepal Share Markets and Finance Ltd."},{"id":43,"name":"NIC Asia Bank Ltd."},{"id":44,"name":"NMB Bank Ltd."},{"id":45,"name":"Pokhara Finance Ltd."},{"id":46,"name":"Prabhu Bank Ltd."},{"id":47,"name":"Prime Commercial Bank Ltd."},{"id":48,"name":"Progressive Finance Ltd."},{"id":49,"name":"Rastriya Banijya Bank Ltd."},{"id":50,"name":"Reliance Finance Ltd."},{"id":51,"name":"Sahara Bikas Bank Ltd."},{"id":52,"name":"Salapa Bikash Bank Ltd."},{"id":53,"name":"Samriddhi Finance Company Ltd."},{"id":54,"name":"Sanima Bank Ltd."},{"id":55,"name":"Saptakoshi Development Bank Ltd."},{"id":56,"name":"Shangri-la Development Bank Ltd."},{"id":57,"name":"Shine Resunga Development Bank Ltd."},{"id":58,"name":"Shree Investment & Finance Co. Ltd."},{"id":59,"name":"Siddhartha Bank Ltd."},{"id":60,"name":"Sindhu Bikas Bank Ltd."},{"id":61,"name":"Standard Chartered Bank Ltd."},{"id":62,"name":"Sunrise Bank Ltd."}],
      bankValues: [{"id":1,"name":'Global IME Bank Ltd.',"nepali":'ग्लोबल आइएमई बैंक लिमिटेड'},{"id":2,"name":'Agriculture Development Bank Ltd.',"nepali":'कृषि विकास बैंक लिमिटेड'},{"id":3,"name":'NMB Bank Ltd.',"nepali":'एनएमवि बैंक लिमिटेड'},{"id":4,"name":'Nepal Investment Bank Ltd. ',"nepali":'नेपाल इन्भेष्टमेण्ट बैंक लिमिटेड'},{"id":5,"name":'Prime Commercial Bank Ltd.',"nepali":'प्राइम कमर्सियल बैंक लिमिटेड'},{"id":6,"name":'Mega Bank Nepal Ltd.',"nepali":'मेघा बैंक लिमिटेड'},{"id":7,"name":'Kumari Bank Ltd.',"nepali":'कुमारी बैंक लिमिटेड'},{"id":8,"name":'Nabil Bank Ltd.',"nepali":'नविल बैंक लिमिटेड'},{"id":9,"name":'Nepal Bank Ltd.',"nepali":'नेपाल बैंक लिमिटेड'},{"id":10,"name":'Citizens Bank International Ltd.',"nepali":'सिटिजन्स बैंक इन्टरनेसनल बैक लिमिटेड'},{"id":11,"name":'NIC Asia Bank Ltd.',"nepali":'एन आइ सी एशिया बैक लिमिटेड'},{"id":12,"name":'Prabhu Bank Ltd.',"nepali":'प्रभु बैंक लिमिटेड'},{"id":13,"name":'Siddhartha Bank Ltd.',"nepali":'सिद्धार्थ बैंक लिमिटेड'},{"id":14,"name":'Laxmi Bank Ltd.',"nepali":'लक्ष्मी बैंक लिमिटेड'},{"id":15,"name":'Himalayan Bank Ltd. ',"nepali":'हिमालयन बैक लिमिटेड'},{"id":16,"name":'Nepal Credit & Commerce Bank Ltd.',"nepali":'नेपाल क्रेडिट एण्ड कमर्स बैक लिमिटेड'},{"id":17,"name":'Sanima Bank Ltd.',"nepali":'सानिमा बैक लिमिटेड'},{"id":18,"name":'Bank of Kathmandu Ltd.',"nepali":'बैक अफ काठमाडौ'},{"id":19,"name":'Nepal SBI Bank Ltd.',"nepali":'नेपाल एसबिआई बैक लिमिटेड'},{"id":20,"name":'Sunrise Bank Ltd.',"nepali":'सनराइज् बैक लिमिटेड'},{"id":21,"name":'Rastriya Banijya Bank Ltd.',"nepali":'राष्ट्रिय वाणिज्य बैंक लिमिटेड'},{"id":22,"name":'Machhapuchhre Bank Ltd.',"nepali":'माछापुच्छ्रे बैंक लिमिटेड'},{"id":23,"name":'Century Commercial Bank Ltd.',"nepali":'सेन्चुरी कमर्सियल बैंक लिमिटेड'},{"id":24,"name":'Nepal Bangladesh Bank Ltd.',"nepali":'नेपाल बाङ्लादेश बैंक '},{"id":25,"name":'Everest Bank Ltd.',"nepali":'एभरेष्ट बैंक लिमिटेड'},{"id":26,"name":'Civil Bank Ltd.',"nepali":'सिभिल बैंक लिमिटेड'},{"id":27,"name":'Standard Chartered Bank Ltd.',"nepali":'स्टयाण्डर्ड चार्टर्ड बैंक नेपाल लिमिटेड'},{"id":28,"name":'Muktinath Bikash Bank Ltd.',"nepali":'मुक्तिनाथ विकास बैंक लिमिटेड'},{"id":29,"name":'Jyoti Bikas Bank Ltd.',"nepali":'ज्योति विकास बैक लिमिटेड'},{"id":30,"name":'Garima Bikas Bank Ltd.',"nepali":'गरिमा विकास बैक लिमिटेड'},{"id":31,"name":'Shine Resunga Development Bank Ltd.',"nepali":'साइन रेसुङ्गा डेभलपमेण्ट बैंक लिमिटेड'},{"id":32,"name":'Mahalaxmi Development Bank Ltd.',"nepali":'महालक्ष्मी डेभलपमेण्ट बैंक लिमिटेड'},{"id":33,"name":'Lumbini Bikash Bank Ltd.',"nepali":'लुम्बिनी विकास बैंक लिमिटेड'},{"id":34,"name":'Kamana Sewa Bikas Bank Ltd.',"nepali":'कामना सेवा विकास बैंक लिमिटेड'},{"id":35,"name":'Shangri-la Development Bank Ltd.',"nepali":'सङ्ग्रिला डेभलपमेण्ट बैंक लिमिटेड'},{"id":36,"name":'Saptakoshi Development Bank Ltd.',"nepali":'सप्तकोशी विकास बैंक लिमिटेड'},{"id":37,"name":'Excel Development Bank Ltd.',"nepali":'एक्सल विकास बैंक लिमिटेड'},{"id":38,"name":'Miteri Development Bank Ltd.',"nepali":'मिटेरी डेभलपमेण्ट बैंक लिमिटेड'},{"id":39,"name":'Sindhu Bikas Bank Ltd.',"nepali":'सिन्धु विकास बैंक लिमिटेड'},{"id":40,"name":'Karnali Development Bank Ltd.',"nepali":'कर्णाली विकास बैंक लिमिटेड'},{"id":41,"name":'Green Development Bank Ltd.',"nepali":'ग्रिन विकास बैंक लिमिटेड'},{"id":42,"name":'Corporate Development Bank Ltd.',"nepali":'करपोरेट विकास बैक लिमिटेड'},{"id":43,"name":'Sahara Bikas Bank Ltd. (Under Acquisition process with Garima Bikash Bank)',"nepali":'साहरा विकास बैक लिमिटेड'},{"id":44,"name":'Narayani Development Bank Ltd.',"nepali":'नारायणी विकास बैक लिमिटेड'},{"id":45,"name":'Salapa Bikash Bank Ltd.',"nepali":'सालपा विकास बैक लिमिटेड'},{"id":46,"name":'ICFC Finance Ltd.',"nepali":'आइ.सि.एफ.सि फाइनान्स लिमिटेड'},{"id":47,"name":'Manjushree Finance Ltd.',"nepali":'मञ्जुश्री फाइनान्स लिमिटेड'},{"id":48,"name":'Pokhara Finance Ltd.',"nepali":'पोखरा फाइनान्स लिमिटेड'},{"id":49,"name":'Capital Merchant Banking & Finance Ltd.',"nepali":'क्यापिटल मर्चेन्ट बैंकिङ एण्ड फाइनान्स लिमिटेड'},{"id":50,"name":'Shree Investment & Finance Co. Ltd.',"nepali":'श्री इन्भेष्टमेण्ट एण्ड फाइनान्स को.लिमिटेड'},{"id":51,"name":'Central Finance Ltd.',"nepali":'सेन्ट्रल फाइनान्स लिमिटेड'},{"id":52,"name":'Gorkhas Finance Ltd.',"nepali":'गोर्खाज फाइनान्स लिमिटेड'},{"id":53,"name":'Goodwill Finance Ltd.',"nepali":'गुडविल फाइनान्स लिमिटेड'},{"id":54,"name":'Guheshwori Merchant Banking & Finance Ltd.',"nepali":'गुहेश्वरी मर्चेन्ट बैंकिङ एण्ड फाइनान्स लिमिटेड'},{"id":55,"name":'Reliance Finance Ltd.',"nepali":'रिलायन्स फाइनान्स लिमिटेड'},{"id":56,"name":'Best Finance Ltd.',"nepali":' बेष्ट फाइनान्स लिमिटेड'},{"id":57,"name":'Progressive Finance Ltd.',"nepali":'प्रोगेसिभ फाइनान्स लिमिटेड'},{"id":58,"name":'Janaki Finance Co. Ltd.',"nepali":'जानकी फाइनान्स को. लिमिटेड'},{"id":59,"name":'Samriddhi Finance Company Ltd.',"nepali":'समृद्धि फाइनान्स कम्पनी लिमिटेड '},{"id":60,"name":'Multipurpose Finance Co. Ltd.',"nepali":'मल्टिप्रपोज फाइनान्स को. लिमिटेड'},{"id":61,"name":'Nepal Finance Ltd.',"nepali":'नेपाल फाइनान्स लिमिटेड'},{"id":62,"name":'Nepal Share Markets and Finance Ltd.',"nepali":'नेपाल सेयर मार्केटस् एण्ड फाइनान्स लिमिटेड'}],
      // districtList: [{"id":1,"name":"Achham District"},{"id":2,"name":"Arghakhanchi District"},{"id":3,"name":"Baglung District"},{"id":4,"name":"Baitadi District"},{"id":5,"name":"Bajhang District"},{"id":6,"name":"Bajura District"},{"id":7,"name":"Banke District"},{"id":8,"name":"Bara District"},{"id":9,"name":"Bardiya District"},{"id":10,"name":"Bhaktapur District"},{"id":11,"name":"Bhojpur District"},{"id":12,"name":"Chitwan District"},{"id":13,"name":"Dadeldhura District"},{"id":14,"name":"Dailekh District"},{"id":15,"name":"Dang District"},{"id":16,"name":"Darchula District"},{"id":17,"name":"Dhading District"},{"id":18,"name":"Dhankuta District"},{"id":19,"name":"Dhanusa District"},{"id":20,"name":"Dolakha District"},{"id":21,"name":"Dolpa District"},{"id":22,"name":"Doti District"},{"id":23,"name":"Eastern Rukum District"},{"id":24,"name":"Gorkha District"},{"id":25,"name":"Gulmi District"},{"id":26,"name":"Humla District"},{"id":27,"name":"Ilam District"},{"id":28,"name":"Jajarkot District"},{"id":29,"name":"Jhapa District"},{"id":30,"name":"Jumla District"},{"id":31,"name":"Kailali District"},{"id":32,"name":"Kalikot District"},{"id":33,"name":"Kanchanpur District"},{"id":34,"name":"Kapilvastu District"},{"id":35,"name":"Kaski District"},{"id":36,"name":"Kathmandu District"},{"id":37,"name":"Kavrepalanchok District"},{"id":38,"name":"Khotang District"},{"id":39,"name":"Lalitpur District"},{"id":40,"name":"Lamjung District"},{"id":41,"name":"Mahottari District"},{"id":42,"name":"Makwanpur District"},{"id":43,"name":"Manang District"},{"id":44,"name":"Morang District"},{"id":45,"name":"Mugu District"},{"id":46,"name":"Mustang District"},{"id":47,"name":"Myagdi District"},{"id":48,"name":"Nawalpur District"},{"id":49,"name":"Nuwakot District"},{"id":50,"name":"Okhaldhunga District"},{"id":51,"name":"Palpa District"},{"id":52,"name":"Panchthar District"},{"id":53,"name":"Parasi District"},{"id":54,"name":"Parbat District"},{"id":55,"name":"Parsa District"},{"id":56,"name":"Pyuthan District"},{"id":57,"name":"Ramechhap District"},{"id":58,"name":"Rasuwa District"},{"id":59,"name":"Rautahat District"},{"id":60,"name":"Rolpa District"},{"id":61,"name":"Rupandehi District"},{"id":62,"name":"Salyan District"},{"id":63,"name":"Sankhuwasabha District"},{"id":64,"name":"Saptari District"},{"id":65,"name":"Sarlahi District"},{"id":66,"name":"Sindhuli District"},{"id":67,"name":"Sindhupalchok District"},{"id":68,"name":"Siraha District"},{"id":69,"name":"Solukhumbu District"},{"id":70,"name":"Sunsari District"},{"id":71,"name":"Surkhet District"},{"id":72,"name":"Syangja District"},{"id":73,"name":"Tanahun District"},{"id":74,"name":"Taplejung District"},{"id":75,"name":"Terhathum District"},{"id":76,"name":"Udayapur District"},{"id":77,"name":"Western Rukum District"}],
      districtList: [{"id":1,"name":'Achham',"nepali":'अछाम'},{"id":2,"name":'Arghakhanchi',"nepali":'अर्घाखाँची'},{"id":3,"name":'Baglung',"nepali":'बाग्लुङ'},{"id":4,"name":'Baitadi',"nepali":'वैतडी'},{"id":5,"name":'Bajhang',"nepali":'बझाङ'},{"id":6,"name":'Bajura',"nepali":'बाजुरा'},{"id":7,"name":'Banke',"nepali":'बाँके'},{"id":8,"name":'Bara',"nepali":'बारा'},{"id":9,"name":'Bardiya',"nepali":'बर्दिया'},{"id":10,"name":'Bhaktapur',"nepali":'भक्तपुर'},{"id":11,"name":'Bhojpur',"nepali":'भोजपुर'},{"id":12,"name":'Chitawan',"nepali":'चितवन'},{"id":13,"name":'Dadeldhura',"nepali":'दैलेख'},{"id":14,"name":'Dailekh',"nepali":'डडेल्धुरा'},{"id":15,"name":'Dang',"nepali":'दाङ'},{"id":16,"name":'Darchula',"nepali":'दार्चुला'},{"id":17,"name":'Dhading',"nepali":'धादिङ'},{"id":18,"name":'Dhankuta',"nepali":'धनकुटा'},{"id":19,"name":'Dhanusa',"nepali":'धनुषा'},{"id":20,"name":'Dolakha',"nepali":'दोलखा'},{"id":21,"name":'Dolpa',"nepali":'डोल्पा'},{"id":22,"name":'Doti',"nepali":'डोटी'},{"id":23,"name":'Gorkha',"nepali":'गोरखा'},{"id":24,"name":'Gulmi',"nepali":'गुल्मी'},{"id":25,"name":'Humla',"nepali":'हुम्ला'},{"id":26,"name":'Ilam',"nepali":'इलाम'},{"id":27,"name":'Jajarkot',"nepali":'जाजरकोट'},{"id":28,"name":'Jhapa',"nepali":'झापा'},{"id":29,"name":'Jumla',"nepali":'जुम्ला'},{"id":30,"name":'Kailali',"nepali":'कैलाली'},{"id":31,"name":'Kalikot',"nepali":'कालिकोट'},{"id":32,"name":'Kanchanpur',"nepali":'कन्चनपुर'},{"id":33,"name":'Kapilbastu',"nepali":'कपिलवस्तु'},{"id":34,"name":'Kaski',"nepali":'कास्की'},{"id":35,"name":'Kathmandu',"nepali":'काठमाडौँ'},{"id":36,"name":'Kavrepalanchok',"nepali":'काभ्रेपालाञ्चोक'},{"id":37,"name":'Khotang',"nepali":'खोटाङ'},{"id":38,"name":'Lalitpur',"nepali":'ललितपुर'},{"id":39,"name":'Lamjung',"nepali":'लमजुङ'},{"id":40,"name":'Mahottari',"nepali":'महोत्तरी'},{"id":41,"name":'Makwanpur',"nepali":'मकवानपुर'},{"id":42,"name":'Manang',"nepali":'मनाङ'},{"id":43,"name":'Morang',"nepali":'मोरङ'},{"id":44,"name":'Mugu',"nepali":'मुगु'},{"id":45,"name":'Mustang',"nepali":'मुस्ताङ'},{"id":46,"name":'Myagdi',"nepali":'म्याग्दी'},{"id":47,"name":'Nawalparasi East',"nepali":'नवलपरासी ( बर्दघाट सुस्ता पूर्व )'},{"id":48,"name":'Nawalparasi West',"nepali":'नवलपरासी ( बर्दघाट सुस्ता पश्चिम )'},{"id":49,"name":'Nuwakot',"nepali":'नुवाकोट'},{"id":50,"name":'Okhaldhunga',"nepali":'ओखलढुङ्गा'},{"id":51,"name":'Palpa',"nepali":'पाल्पा'},{"id":52,"name":'Panchthar',"nepali":'पाँचथर'},{"id":53,"name":'Parbat',"nepali":'पर्वत'},{"id":54,"name":'Parsa',"nepali":'पर्सा'},{"id":55,"name":'Pyuthan',"nepali":'प्युठान'},{"id":56,"name":'Ramechhap',"nepali":'रामेछाप'},{"id":57,"name":'Rasuwa',"nepali":'रसुवा'},{"id":58,"name":'Rautahat',"nepali":'रौतहट'},{"id":59,"name":'Rolpa',"nepali":'रोल्पा'},{"id":60,"name":'Rukum East',"nepali":'रुकुम ( पूर्वी भाग )'},{"id":61,"name":'Rukum West',"nepali":'रुकुम ( पश्चिम भाग)'},{"id":62,"name":'Rupandehi',"nepali":'रुपन्देही'},{"id":63,"name":'Salyan',"nepali":'सल्यान'},{"id":64,"name":'Sankhuwasabha',"nepali":'संखुवासभा'},{"id":65,"name":'Saptari',"nepali":'सप्तरी'},{"id":66,"name":'Sarlahi',"nepali":'सर्लाही'},{"id":67,"name":'Sindhuli',"nepali":'सिन्धुली'},{"id":68,"name":'Sindhupalchok',"nepali":'सिन्धुपाल्चोक'},{"id":69,"name":'Siraha',"nepali":'सिराहा'},{"id":70,"name":'Solukhumbu',"nepali":'सोलुखुम्बु'},{"id":71,"name":'Sunsari',"nepali":'सुनसरी'},{"id":72,"name":'Surkhet',"nepali":'सुर्खेत'},{"id":73,"name":'Syangja',"nepali":'स्याङ्जा'},{"id":74,"name":'Tanahu',"nepali":'तनहुँ'},{"id":75,"name":'Taplejung',"nepali":'ताप्लेजुङ'},{"id":76,"name":'Terhathum',"nepali":'तेह्रथुम'},{"id":77,"name":'Udayapur',"nepali":'उदयपुर'}],
      municipality: [[],
        [
          { "id": 1, "name": 'Bannigadhi Jayagadh', "nepali": 'बान्नीगढी जयगढ ' },
          { "id": 2, "name": 'Chaurpati', "nepali": 'चौरपाटी ' },
          { "id": 3, "name": 'Dhakari', "nepali": 'ढकारी' },
          { "id": 4, "name": 'Kamalbazar', "nepali": 'कमलबजार' },
          { "id": 5, "name": 'Mangalsen', "nepali": 'मंगलसेन' },
          { "id": 6, "name": 'Mellekh', "nepali": 'मेल्लेख ' },
          { "id": 7, "name": 'Panchadewal Binayak', "nepali": 'पंचदेवल विनायक' },
          { "id": 8, "name": 'Ramaroshan', "nepali": 'रामारोशन' },
          { "id": 9, "name": 'Sanphebagar', "nepali": 'साँफेबगर' },
          { "id": 10, "name": 'Turmakhad', "nepali": 'तुर्माखाद ' }
        ],
        [
          { "id": 11, "name": 'Bhumekasthan', "nepali": 'भुमिकास्थान ' },
          { "id": 12, "name": 'Chhatradev', "nepali": 'छत्रदेव' },
          { "id": 13, "name": 'Malarani', "nepali": 'मालारानी ' },
          { "id": 14, "name": 'Panini', "nepali": 'पाणिनी ' },
          { "id": 15, "name": 'Sandhikharka', "nepali": 'सन्धिखर्क ' },
          { "id": 16, "name": 'Sitganga', "nepali": 'शितगंगा ' }
        ],
        [
          { "id": 17, "name": 'Badigad', "nepali": 'वडिगाड ' },
          { "id": 18, "name": 'Baglung', "nepali": 'बागलुङ' },
          { "id": 19, "name": 'Bareng', "nepali": 'वरेङ ' },
          { "id": 20, "name": 'Dhorpatan', "nepali": 'ढोरपाटन ' },
          { "id": 21, "name": 'Galkot', "nepali": 'गल्कोट ' },
          { "id": 22, "name": 'Jaimuni', "nepali": 'जैमिनी' },
          { "id": 23, "name": 'Kanthekhola', "nepali": 'काठेखोला' },
          { "id": 24, "name": 'Nisikhola', "nepali": 'निसीखोला' },
          { "id": 25, "name": 'Taman Khola', "nepali": 'तमानखोला' },
          { "id": 26, "name": 'Tara Khola', "nepali": 'ताराखोला' }
        ],
        [
          { "id": 27, "name": 'Dasharathchanda', "nepali": 'दशरथचन्द' },
          { "id": 28, "name": 'Dilasaini', "nepali": 'डिलासैनी' },
          { "id": 29, "name": 'Dogadakedar', "nepali": 'दोगडाकेदार' },
          { "id": 30, "name": 'Melauli', "nepali": 'मेलौली' },
          { "id": 31, "name": 'Pancheshwar', "nepali": 'पन्चेश्वर' },
          { "id": 32, "name": 'Patan', "nepali": 'पाटन' },
          { "id": 33, "name": 'Purchaudi', "nepali": 'पुर्चौडी' },
          { "id": 34, "name": 'Shivanath', "nepali": 'शिवनाथ' },
          { "id": 35, "name": 'Sigas', "nepali": 'सिगास' },
          { "id": 36, "name": 'Surnaya', "nepali": 'सुर्नया' }
        ],
        [
          { "id": 37, "name": 'Bithadchir', "nepali": 'वित्थडचिर ' },
          { "id": 38, "name": 'Bungal', "nepali": 'बुंगल' },
          { "id": 39, "name": 'Chabispathivera', "nepali": 'छविसपाथिभेरा ' },
          { "id": 40, "name": 'Durgathali', "nepali": 'दुर्गाथली ' },
          { "id": 41, "name": 'JayaPrithivi', "nepali": 'जयपृथ्वी ' },
          { "id": 42, "name": 'Kedarseu', "nepali": 'केदारस्युँ ' },
          { "id": 43, "name": 'Khaptadchhanna', "nepali": 'खप्तडछान्ना ' },
          { "id": 44, "name": 'Masta', "nepali": 'मष्टा' },
          { "id": 45, "name": 'SaiPaal', "nepali": 'सैपाल' },
          { "id": 46, "name": 'Surma', "nepali": 'सूर्मा ' },
          { "id": 47, "name": 'Talkot', "nepali": 'तलकोट ' },
          { "id": 48, "name": 'Thalara', "nepali": 'थलारा ' }
        ],
        [
          { "id": 49, "name": 'Badimalika', "nepali": 'बडिमालिका' },
          { "id": 50, "name": 'Budhiganga', "nepali": 'बुढिगंगा' },
          { "id": 51, "name": 'Budhinanda', "nepali": 'बुढिनन्दा' },
          { "id": 52, "name": 'Gaumul', "nepali": 'गौमुल' },
          { "id": 53, "name": 'Himali', "nepali": 'हिमाली' },
          { "id": 54, "name": 'Jagannath', "nepali": 'जगन्नाथ' },
          {
            "id": 55,
            "name": 'Khaptad Chhededaha',
            "nepali": 'स्वामिकार्तिक खापर '
          },
          { "id": 56, "name": 'Swami Kartik Khaapar', "nepali": 'खप्तड छेडेदह' },
          { "id": 57, "name": 'Tribeni', "nepali": 'त्रिवेणी' }
        ],
        [
          { "id": 58, "name": 'Baijanath', "nepali": 'बैजनाथ' },
          { "id": 59, "name": 'Duduwa', "nepali": 'डुडुवा ' },
          { "id": 60, "name": 'Janki', "nepali": 'जानकी ' },
          { "id": 61, "name": 'Khajura', "nepali": 'खजुरा ' },
          { "id": 62, "name": 'Kohalpur', "nepali": 'कोहलपुर ' },
          { "id": 63, "name": 'Narainapur', "nepali": 'नरैनापुर' },
          {
            "id": 64,
            "name": 'Nepalgunj Sub-Metropolitian City',
            "nepali": 'नेपालगँज '
          },
          { "id": 65, "name": 'Rapti Sonari', "nepali": 'राप्तीसोनारी ' }
        ],
        [
          { "id": 66, "name": 'Adarshkotwal', "nepali": 'आदर्श कोटवाल' },
          { "id": 67, "name": 'Baragadhi', "nepali": 'बारागढी' },
          { "id": 68, "name": 'Bishrampur', "nepali": 'बिश्रामपुर' },
          { "id": 69, "name": 'Devtal', "nepali": 'देवताल' },
          {
            "id": 70,
            "name": 'Jitpur Simara Sub-Metropolitian City',
            "nepali": 'जीतपुरसिमरा'
          },
          { "id": 71, "name": 'Kalaiya Sub-Metropolitian City', "nepali": 'कलैया' },
          { "id": 72, "name": 'Karaiyamai', "nepali": 'करैयामाई' },
          { "id": 73, "name": 'Kolhabi', "nepali": 'कोल्हवी ' },
          { "id": 74, "name": 'Mahagadhimai', "nepali": 'महागढीमाई ' },
          { "id": 75, "name": 'Nijgadh', "nepali": 'निजगढ ' },
          { "id": 76, "name": 'Pacharauta', "nepali": 'पचरौता ' },
          { "id": 77, "name": 'Parwanipur', "nepali": 'परवानीपुर' },
          { "id": 78, "name": 'Pheta', "nepali": 'फेटा' },
          { "id": 79, "name": 'Prasauni', "nepali": 'प्रसौनी' },
          { "id": 80, "name": 'Simraungadh', "nepali": 'सिम्रौनगढ ' },
          { "id": 81, "name": 'Suwarna', "nepali": 'सुवर्ण' }
        ],
        [
          { "id": 82, "name": 'Badhaiyatal', "nepali": 'बढैयाताल' },
          { "id": 83, "name": 'Bansagadhi', "nepali": 'बाँसगढी' },
          { "id": 84, "name": 'Barbardiya', "nepali": 'बारबर्दिया' },
          { "id": 85, "name": 'Geruwa', "nepali": 'गुलरिया' },
          { "id": 86, "name": 'Gulariya', "nepali": 'गेरुवा' },
          { "id": 87, "name": 'Madhuwan', "nepali": 'मधुवन ' },
          { "id": 88, "name": 'Rajapur', "nepali": 'राजापुर' },
          { "id": 89, "name": 'Thakurbaba', "nepali": 'ठाकुरबाबा' }
        ],
        [
          { "id": 90, "name": 'Bhaktapur', "nepali": 'भक्तपुर' },
          { "id": 91, "name": 'Changunarayan', "nepali": 'चाँगुनारायण' },
          { "id": 92, "name": 'Madhyapur Thimi', "nepali": 'मध्यपुर थिमी' },
          { "id": 93, "name": 'Suryabinayak', "nepali": 'सूर्यविनायक' }
        ],
        [
          { "id": 94, "name": 'Aamchowk', "nepali": 'आमचोक' },
          { "id": 95, "name": 'Arun', "nepali": 'अरुण' },
          { "id": 96, "name": 'Bhojpur', "nepali": 'भोजपुर' },
          { "id": 97, "name": 'Hatuwagadhi', "nepali": 'हतुवागढी' },
          { "id": 98, "name": 'Pauwadungma', "nepali": 'पौवादुङमा' },
          { "id": 99, "name": 'Ramprasad Rai', "nepali": 'रामप्रसादराई' },
          { "id": 100, "name": 'Salpasilichho', "nepali": 'साल्पासिलिछो' },
          { "id": 101, "name": 'Shadananda', "nepali": 'षडानन्द' },
          { "id": 102, "name": 'Temkemaiyung', "nepali": 'टेम्केमैयुम' }
        ],
        [
          { "id": 103, "name": 'Bharatpur Metropolitian City', "nepali": 'भरतपुर' },
          { "id": 104, "name": 'Ichchhyakamana', "nepali": 'इच्छाकामना' },
          { "id": 105, "name": 'Kalika', "nepali": 'कालिका' },
          { "id": 106, "name": 'Khairahani', "nepali": 'खैरहनी' },
          { "id": 107, "name": 'Madi', "nepali": 'माडी' },
          { "id": 108, "name": 'Rapti', "nepali": 'राप्ती' },
          { "id": 109, "name": 'Ratnanagar', "nepali": 'रत्ननगर' }
        ],
        [
          { "id": 110, "name": 'Ajaymeru', "nepali": 'अजयमेरु' },
          { "id": 111, "name": 'Alital', "nepali": 'आलिताल' },
          { "id": 112, "name": 'Amargadhi', "nepali": 'अमरगढी' },
          { "id": 113, "name": 'Bhageshwar', "nepali": 'भागेश्वर' },
          { "id": 114, "name": 'Ganayapdhura', "nepali": 'गन्यापधुरा' },
          { "id": 115, "name": 'Nawadurga', "nepali": 'नवदुर्गा' },
          { "id": 116, "name": 'Parashuram', "nepali": 'परशुराम ' }
        ],
        [
          { "id": 117, "name": 'Aathabis', "nepali": 'आठविस' },
          { "id": 118, "name": 'Bhagawatimai', "nepali": 'भगवतिमाइ' },
          { "id": 119, "name": 'Bhairabi', "nepali": 'भैरवी' },
          {
            "id": 120,
            "name": 'Chamunda Bindrasaini',
            "nepali": 'चामुण्डा विन्द्रासैनी'
          },
          { "id": 121, "name": 'Dullu', "nepali": 'दुल्लु' },
          { "id": 122, "name": 'Dungeshwor', "nepali": 'डुङ्गेश्वर' },
          { "id": 123, "name": 'Gurans', "nepali": 'गुरास' },
          { "id": 124, "name": 'Mahabu', "nepali": 'महावु' },
          { "id": 125, "name": 'Narayan', "nepali": 'नारायण' },
          { "id": 126, "name": 'Naumule', "nepali": 'नौमुले' },
          { "id": 127, "name": 'Thantikandh', "nepali": 'ठाँटीकाध' }
        ],
        [
          { "id": 128, "name": 'Babai', "nepali": 'बबर्इ' },
          { "id": 129, "name": 'Banglachuli', "nepali": 'बँगलाचुली' },
          { "id": 130, "name": 'Dangisharan', "nepali": 'दँगीशरणा' },
          { "id": 131, "name": 'Gadhawa', "nepali": 'गढवा' },
          {
            "id": 132,
            "name": 'Ghorahi Sub-Metropolitian City',
            "nepali": 'घोराही'
          },
          { "id": 133, "name": 'Lamahi', "nepali": '' },
          { "id": 134, "name": 'Rajpur', "nepali": 'राजपुर' },
          { "id": 135, "name": 'Rapti', "nepali": 'राप्ती' },
          { "id": 136, "name": 'Shantinagar', "nepali": 'शान्तिनगर' },
          {
            "id": 137,
            "name": 'Tulsipur Sub-Metropolitian City',
            "nepali": 'तुल्सीपुर'
          }
        ],
        [
          { "id": 138, "name": 'Apihimal', "nepali": 'अपिहिमाल' },
          { "id": 139, "name": 'Byas', "nepali": 'व्यास' },
          { "id": 140, "name": 'Dunhu', "nepali": 'दुहुँ' },
          { "id": 141, "name": 'Lekam', "nepali": 'लेकम' },
          { "id": 142, "name": 'Mahakali', "nepali": 'माहाकाली' },
          { "id": 143, "name": 'Malikaarjun', "nepali": 'मालिकार्जुन' },
          { "id": 144, "name": 'Marma', "nepali": 'मार्मा' },
          { "id": 145, "name": 'Naugad', "nepali": 'नौगाड' },
          { "id": 146, "name": 'Shailyashikhar', "nepali": 'ल्यशिखर' }
        ],
        [
          { "id": 147, "name": 'Benighat Rorang', "nepali": 'बेनीघाट रोराङ्ग' },
          { "id": 148, "name": 'Dhunibesi', "nepali": 'धुनीबेंशी' },
          { "id": 149, "name": 'Gajuri', "nepali": 'गजुरी' },
          { "id": 150, "name": 'Galchi', "nepali": 'गल्छी' },
          { "id": 151, "name": 'Gangajamuna', "nepali": 'गङ्गाजमुना' },
          { "id": 152, "name": 'Jwalamukhi', "nepali": 'ज्वालामूखी' },
          { "id": 153, "name": 'Khaniyabash', "nepali": 'खनियाबास' },
          { "id": 154, "name": 'Netrawati Dabjong', "nepali": 'नेत्रावती डबजोङ' },
          { "id": 155, "name": 'Nilakantha', "nepali": 'नीलकण्ठ ' },
          { "id": 156, "name": 'Rubi Valley', "nepali": 'रुवी भ्याली' },
          { "id": 157, "name": 'Siddhalek', "nepali": 'सिद्धलेक' },
          { "id": 158, "name": 'Thakre', "nepali": 'थाक्रे' },
          { "id": 159, "name": 'Tripura Sundari', "nepali": 'त्रिपुरासुन्दरी' }
        ],
        [
          { "id": 160, "name": 'Chaubise', "nepali": 'चौबिसे' },
          { "id": 161, "name": 'Chhathar Jorpati', "nepali": 'छथर जोरपाटी' },
          { "id": 162, "name": 'Dhankuta', "nepali": 'धनकुटा' },
          { "id": 163, "name": 'Mahalaxmi', "nepali": 'महालक्ष्मी' },
          { "id": 164, "name": 'Pakhribas', "nepali": 'पाख्रिवास' },
          { "id": 165, "name": 'Sangurigadhi', "nepali": 'साँगुरीगढी' },
          { "id": 166, "name": 'Shahidbhumi', "nepali": 'सहिदभुमि' }
        ],
        [
          { "id": 167, "name": 'Aaurahi', "nepali": 'औरहि' },
          { "id": 168, "name": 'Bateshwor', "nepali": 'बटेश्वर' },
          { "id": 169, "name": 'Bideha', "nepali": 'विदेह' },
          { "id": 170, "name": 'Chhireshwornath', "nepali": 'क्षिरेश्वरनाथ' },
          { "id": 171, "name": 'Dhanauji', "nepali": 'धनौजी' },
          { "id": 172, "name": 'Dhanusadham', "nepali": 'धनुषाधाम' },
          { "id": 173, "name": 'Ganeshman Charnath', "nepali": 'गणेशमान चारनाथ' },
          { "id": 174, "name": 'Hansapur', "nepali": 'हंसपुर' },
          { "id": 175, "name": 'Janaknandani', "nepali": 'जनकनन्दिनी' },
          {
            "id": 176,
            "name": 'Janakpurdham Sub-Metropolitian City',
            "nepali": 'जनकपुरधाम'
          },
          { "id": 177, "name": 'Kamala', "nepali": 'कमला' },
          { "id": 178, "name": 'Lakshminiya', "nepali": 'लक्ष्मिनिया' },
          { "id": 179, "name": 'Mithila Bihari', "nepali": 'मिथिला बिहारी' },
          { "id": 180, "name": 'Mithila', "nepali": 'मिथिला' },
          {
            "id": 181,
            "name": 'Mukhiyapatti Musarmiya',
            "nepali": 'मुखियापट्टी मुसहरमिया'
          },
          { "id": 182, "name": 'Nagarain', "nepali": 'नगराइन' },
          { "id": 183, "name": 'Sabaila', "nepali": 'सबैला' },
          { "id": 184, "name": 'Sahidnagar', "nepali": 'शहिदनगर' }
        ],
        [
          { "id": 185, "name": 'Baiteshwor', "nepali": 'वैतेश्वर' },
          { "id": 186, "name": 'Bhimeshwor', "nepali": 'भिमेश्वर' },
          { "id": 187, "name": 'Bigu', "nepali": 'विगु' },
          { "id": 188, "name": 'Gaurishankar', "nepali": 'गौरिशंकर' },
          { "id": 189, "name": 'Jiri', "nepali": 'जिरी' },
          { "id": 190, "name": 'Kalinchok', "nepali": 'कालिन्चोक' },
          { "id": 191, "name": 'Melung', "nepali": 'मेलुङ' },
          { "id": 192, "name": 'Sailung', "nepali": 'शैलुङ' },
          { "id": 193, "name": 'Tamakoshi', "nepali": 'तामाकोशी' }
        ],
        [
          { "id": 194, "name": 'Chharka Tangsong', "nepali": 'छार्का ताङसोङ' },
          { "id": 195, "name": 'Dolpo Buddha', "nepali": 'डोल्पा वुद्ध' },
          { "id": 196, "name": 'Jagadulla', "nepali": 'जगदुल्ला' },
          { "id": 197, "name": 'Kaike', "nepali": 'काइके' },
          { "id": 198, "name": 'Mudkechula', "nepali": 'मुड्केचुला' },
          { "id": 199, "name": 'Shey Phoksundo', "nepali": 'शे फोक्सुण्डो' },
          { "id": 200, "name": 'Thuli Bheri', "nepali": 'ठुलिभेरी' },
          { "id": 201, "name": 'Tripurasundari', "nepali": 'त्रिपुरासुन्दरी' }
        ],
        [
          { "id": 202, "name": 'Adharsha', "nepali": 'आदर्श' },
          { "id": 203, "name": 'Badikedar', "nepali": 'बुडिकेदार' },
          { "id": 204, "name": 'Bogtan Foodsil', "nepali": 'बोगटान' },
          { "id": 205, "name": 'Dipayal Silgadi', "nepali": 'दिपायल सिलगढी' },
          { "id": 206, "name": 'Jorayal', "nepali": 'जोरायल' },
          { "id": 207, "name": 'K I Singh', "nepali": 'के.आइ.सिं' },
          { "id": 208, "name": 'Purbichauki', "nepali": 'पुर्विचौकी' },
          { "id": 209, "name": 'Sayal', "nepali": 'सायल' },
          { "id": 210, "name": 'Shikhar', "nepali": 'शिखर' }
        ],
        [
          { "id": 211, "name": 'Aarughat', "nepali": 'आरुघाट ' },
          { "id": 212, "name": 'Ajirkot', "nepali": 'अजिरकोट ' },
          { "id": 213, "name": 'Barpak Sulikot', "nepali": 'बारपाक सुलिकोट ' },
          { "id": 214, "name": 'Bhimsenthapa', "nepali": 'भिमसेनथापा' },
          { "id": 215, "name": 'Chum Nubri', "nepali": 'चुमनुव्री ' },
          { "id": 216, "name": 'Dharche', "nepali": 'धार्चे ' },
          { "id": 217, "name": 'Gandaki', "nepali": 'गण्डकी ' },
          { "id": 218, "name": 'Gorkha', "nepali": 'गोरखा' },
          { "id": 219, "name": 'Palungtar', "nepali": 'पालुङटार' },
          { "id": 220, "name": 'Sahid Lakhan', "nepali": 'शहिद लखन ' },
          { "id": 221, "name": 'Siranchok', "nepali": 'सिरानचोक' }
        ],
        [
          { "id": 222, "name": 'Chandrakot', "nepali": 'चन्द्रकोट' },
          { "id": 223, "name": 'Chatrakot', "nepali": 'छत्रकोट' },
          { "id": 224, "name": 'Dhurkot', "nepali": 'धुर्कोट' },
          { "id": 225, "name": 'Gulmidarbar', "nepali": 'गुल्मीदरबार' },
          { "id": 226, "name": 'Isma', "nepali": 'इस्मा' },
          { "id": 227, "name": 'Kaligandaki', "nepali": 'कालीगण्डकी' },
          { "id": 228, "name": 'Madane', "nepali": 'मदाने' },
          { "id": 229, "name": 'Malika', "nepali": 'मालिका' },
          { "id": 230, "name": 'Musikot', "nepali": 'मुसिकोट' },
          { "id": 231, "name": 'Resunga', "nepali": 'रेसुङ्गा' },
          { "id": 232, "name": 'Ruru', "nepali": 'रुरु' },
          { "id": 233, "name": 'Satyawati', "nepali": 'सत्यवती' }
        ],
        [
          { "id": 234, "name": 'Adanchuli', "nepali": 'अदानचुली' },
          { "id": 235, "name": 'Chankheli', "nepali": 'चंखेली' },
          { "id": 236, "name": 'Kharpunath', "nepali": 'खार्पुनाथ' },
          { "id": 237, "name": 'Namkha', "nepali": 'नाम्खा' },
          { "id": 238, "name": 'Sarkegad', "nepali": 'सर्केगाड' },
          { "id": 239, "name": 'Simkot', "nepali": 'सिमकोट' },
          { "id": 240, "name": 'Tanjakot', "nepali": 'ताजाकोट' }
        ],
        [
          { "id": 241, "name": 'Chulachuli', "nepali": 'चुलाचुली' },
          { "id": 242, "name": 'Deumai', "nepali": 'देउमाई' },
          { "id": 243, "name": 'Fakphokthum', "nepali": 'फाकफोकथुम' },
          { "id": 244, "name": 'Illam', "nepali": 'ईलाम' },
          { "id": 245, "name": 'Mai', "nepali": 'देउमाई' },
          { "id": 246, "name": 'Maijogmai', "nepali": 'माईजोगमाई' },
          { "id": 247, "name": 'Mangsebung', "nepali": 'माङसेबुङ' },
          { "id": 248, "name": 'Rong', "nepali": 'रोङ' },
          { "id": 249, "name": 'Sandakpur', "nepali": 'सन्दकपुर' },
          { "id": 250, "name": 'Suryodaya', "nepali": 'सूर्योदय' }
        ],
        [
          { "id": 251, "name": 'Barekot', "nepali": 'बारेकोट' },
          { "id": 252, "name": 'Bheri', "nepali": 'भेरी' },
          { "id": 253, "name": 'Chhedagad', "nepali": 'छेडागाड' },
          { "id": 254, "name": 'Junichande', "nepali": 'जुनिचादे' },
          { "id": 255, "name": 'Kuse', "nepali": 'कुसे' },
          { "id": 256, "name": 'Nalagad', "nepali": 'नलगाड' },
          { "id": 257, "name": 'Shiwalaya', "nepali": 'सिवालय' }
        ],
        [
          { "id": 258, "name": 'Arjundhara', "nepali": 'अर्जुनधारा' },
          { "id": 259, "name": 'Barhadashi', "nepali": 'बाह्रदशी' },
          { "id": 260, "name": 'Bhadrapur', "nepali": 'भद्रपुर' },
          { "id": 261, "name": 'Birtamod', "nepali": 'बिर्तामोड' },
          { "id": 262, "name": 'Buddhashanti', "nepali": 'बुद्धशान्ति' },
          { "id": 263, "name": 'Damak', "nepali": 'दमक' },
          { "id": 264, "name": 'Gauradhaha', "nepali": 'गौरादह' },
          { "id": 265, "name": 'Gauriganj', "nepali": 'गौरिगंज' },
          { "id": 266, "name": 'Haldibari', "nepali": 'हल्दीबारी' },
          { "id": 267, "name": 'Jhapa', "nepali": 'झापा' },
          { "id": 268, "name": 'Kachankawal', "nepali": 'कचनकवल' },
          { "id": 269, "name": 'Kamal', "nepali": 'कमल' },
          { "id": 270, "name": 'Kankai', "nepali": 'कन्काई' },
          { "id": 271, "name": 'Mechinagar', "nepali": 'मेचीनगर' },
          { "id": 272, "name": 'Shivasataxi', "nepali": 'शिवसताक्षी' }
        ],
        [
          { "id": 273, "name": 'Chandannath', "nepali": 'चन्दननाथ' },
          { "id": 274, "name": 'Guthichaur', "nepali": 'गुठीचौर' },
          { "id": 275, "name": 'Hima', "nepali": 'हिमा' },
          { "id": 276, "name": 'Kanakasundari', "nepali": 'कनकासुन्दरी' },
          { "id": 277, "name": 'Patrasi', "nepali": 'पातारासी' },
          { "id": 278, "name": 'Sinja', "nepali": 'सिंजा' },
          { "id": 279, "name": 'Tatopani', "nepali": 'तातोपानी' },
          { "id": 280, "name": 'Tila', "nepali": 'तिला' }
        ],
        [
          { "id": 281, "name": 'Bardagoriya', "nepali": 'बर्दगोरिया' },
          { "id": 282, "name": 'Bhajani', "nepali": 'भजनी' },
          { "id": 283, "name": 'Chure', "nepali": 'चुरे' },
          {
            "id": 284,
            "name": 'Dhangadhi Sub-Metropolitian City',
            "nepali": 'धनगढी'
          },
          { "id": 285, "name": 'Gauriganga', "nepali": 'गौरीगंगा' },
          { "id": 286, "name": 'Ghodaghodi', "nepali": 'घोडाघोडी' },
          { "id": 287, "name": 'Godawari', "nepali": 'गोदावरी' },
          { "id": 288, "name": 'Janaki', "nepali": 'जानकी' },
          { "id": 289, "name": 'Joshipur', "nepali": 'जोशिपुर' },
          { "id": 290, "name": 'Kailari', "nepali": 'कैलारी' },
          { "id": 291, "name": 'Lamkichuha', "nepali": 'लम्किचुहा' },
          { "id": 292, "name": 'Mohanyal', "nepali": 'मोहन्याल' },
          { "id": 293, "name": 'Tikapur', "nepali": 'टिकापुर' }
        ],
        [
          { "id": 294, "name": 'Khandachakra', "nepali": 'खाडाचक्र' },
          { "id": 295, "name": 'Mahawai', "nepali": 'महावै' },
          { "id": 296, "name": 'Naraharinath', "nepali": 'नरहरीनाथ' },
          { "id": 297, "name": 'Pachaljharana', "nepali": 'पचालझरना' },
          { "id": 298, "name": 'Palata', "nepali": 'पलता' },
          { "id": 299, "name": 'Raskot', "nepali": 'रास्कोट' },
          { "id": 300, "name": 'Sanni Tribeni', "nepali": 'सान्नी त्रीवेणी' },
          { "id": 301, "name": 'Subha Kalika', "nepali": 'शुभ कालिका' },
          { "id": 302, "name": 'Tilagufa', "nepali": 'तिलागुफा' }
        ],
        [
          { "id": 303, "name": 'Bedkot', "nepali": 'बेदकोट' },
          { "id": 304, "name": 'Belauri', "nepali": 'बेलौरी' },
          { "id": 305, "name": 'Beldandi', "nepali": 'बेलडाँडी' },
          { "id": 306, "name": 'Bhimdatta', "nepali": 'भिमदत्त' },
          { "id": 307, "name": 'Krishnapur', "nepali": 'कृष्णपुर' },
          { "id": 308, "name": 'Laljhadi', "nepali": 'लालझाडी' },
          { "id": 309, "name": 'Mahakali', "nepali": 'माहाकाली' },
          { "id": 310, "name": 'Punarbas', "nepali": 'पुनर्वास' },
          { "id": 311, "name": 'Shuklaphanta', "nepali": 'शुक्लाफाँटा' }
        ],
        [
          { "id": 312, "name": 'Banganga', "nepali": 'बाणगंगा' },
          { "id": 313, "name": 'Bijayanagar', "nepali": 'विजयनगर' },
          { "id": 314, "name": 'Buddhabhumi', "nepali": 'बुद्दभुमी' },
          { "id": 315, "name": 'Kapilbastu', "nepali": 'कपिलवस्तु' },
          { "id": 316, "name": 'Krishnanagar', "nepali": 'कृष्णनगर' },
          { "id": 317, "name": 'Maharajgunj', "nepali": 'महाराजग‌ंज' },
          { "id": 318, "name": 'Mayadevi', "nepali": 'मायादेवी' },
          { "id": 319, "name": 'Shivaraj', "nepali": 'शिवराज' },
          { "id": 320, "name": 'Suddhodhan', "nepali": 'शुद्दोधन' },
          { "id": 321, "name": 'Yashodhara', "nepali": 'यशोधरा' }
        ],
        [
          { "id": 322, "name": 'Annapurna', "nepali": 'अन्नपूर्ण' },
          { "id": 323, "name": 'Machhapuchchhre', "nepali": 'माछापुछ्रे' },
          { "id": 324, "name": 'Madi', "nepali": 'मादी' },
          { "id": 325, "name": 'Pokhara Metropolitian City', "nepali": 'पोखरा' },
          { "id": 326, "name": 'Rupa', "nepali": 'रूपा' }
        ],
        [
          { "id": 327, "name": 'Budhanilakantha', "nepali": 'बुढानिलकण्ठ' },
          { "id": 328, "name": 'Chandragiri', "nepali": 'चन्द्रागिरी' },
          { "id": 329, "name": 'Dakshinkali', "nepali": 'दक्षिणकाली' },
          { "id": 330, "name": 'Gokarneshwor', "nepali": 'गोकर्णेश्वर' },
          {
            "id": 331,
            "name": 'Kageshwori Manahora',
            "nepali": 'कागेश्वरी मनोहरा'
          },
          {
            "id": 332,
            "name": 'Kathmandu Metropolitian City',
            "nepali": 'काठमाडौँ'
          },
          { "id": 333, "name": 'Kirtipur', "nepali": 'कीर्तिपुर' },
          { "id": 334, "name": 'Nagarjun', "nepali": 'नागार्जुन' },
          { "id": 335, "name": 'Shankharapur', "nepali": 'शङ्खरापुर' },
          { "id": 336, "name": 'Tarakeshwor', "nepali": 'तारकेश्वर' },
          { "id": 337, "name": 'Tokha', "nepali": 'टोखा' }
        ],
        [
          { "id": 338, "name": 'Banepa', "nepali": 'बनेपा' },
          { "id": 339, "name": 'Bethanchowk', "nepali": 'बेथानचोक' },
          { "id": 340, "name": 'Bhumlu', "nepali": 'भुम्लु' },
          { "id": 341, "name": 'Chaurideurali', "nepali": 'चौंरीदेउराली' },
          { "id": 342, "name": 'Dhulikhel', "nepali": 'धुलिखेल' },
          { "id": 343, "name": 'Khanikhola', "nepali": 'खानीखोला' },
          { "id": 344, "name": 'Mahabharat', "nepali": 'महाभारत' },
          { "id": 345, "name": 'Mandandeupur', "nepali": 'मण्डनदेउपुर' },
          { "id": 346, "name": 'Namobuddha', "nepali": 'नमोबुद्ध' },
          { "id": 347, "name": 'Panauti', "nepali": 'पनौती' },
          { "id": 348, "name": 'Panchkhal', "nepali": 'पाँचखाल' },
          { "id": 349, "name": 'Roshi', "nepali": 'रोशी' },
          { "id": 350, "name": 'Temal', "nepali": 'तेमाल' }
        ],
        [
          { "id": 351, "name": 'Ainselukhark', "nepali": 'ऐसेलुखर्क' },
          { "id": 352, "name": 'Barahapokhari', "nepali": 'बराहपोखरी' },
          {
            "id": 353,
            "name": 'Diktel Rupakot Majhuwagadhi',
            "nepali": 'दिक्तेल रुपाकोट मझुवागढी'
          },
          {
            "id": 354,
            "name": 'Diprung Chuichumma',
            "nepali": 'दिप्रुङ चुइचुम्मा'
          },
          { "id": 355, "name": 'Halesi Tuwachung', "nepali": 'हलेसीतुवाचुङ' },
          { "id": 356, "name": 'Jantedhunga', "nepali": 'जन्तेढुङ्गा' },
          { "id": 357, "name": 'Kepilasagadhi', "nepali": 'केपिलासगढी' },
          { "id": 358, "name": 'Khotehang', "nepali": 'खोटेहाङ' },
          { "id": 359, "name": 'Rawa Besi', "nepali": 'रावा बेसी' },
          { "id": 360, "name": 'Sakela', "nepali": 'साकेला' }
        ],
        [
          { "id": 361, "name": 'Bagmati', "nepali": 'वाग्मती' },
          { "id": 362, "name": 'Godawari', "nepali": 'गोदावरी' },
          { "id": 363, "name": 'Konjyosom', "nepali": 'कोन्ज्योसोम' },
          { "id": 364, "name": 'Lalitpur Metropolitian City', "nepali": 'ललितपुर' },
          { "id": 365, "name": 'Mahalaxmi', "nepali": 'महालक्ष्मी' },
          { "id": 366, "name": 'Mahankal', "nepali": 'महाङ्काल' }
        ],
        [
          { "id": 367, "name": 'Besishahar', "nepali": 'बेसीशहर' },
          { "id": 368, "name": 'Dordi', "nepali": 'दोर्दी' },
          { "id": 369, "name": 'Dudhpokhari', "nepali": 'दूधपोखरी' },
          { "id": 370, "name": 'Kwholasothar', "nepali": 'क्व्होलासोथार' },
          { "id": 371, "name": 'MadhyaNepal', "nepali": 'मध्यनेपाल' },
          { "id": 372, "name": 'Marsyangdi', "nepali": 'मर्स्याङदी' },
          { "id": 373, "name": 'Rainas', "nepali": 'रार्इनास' },
          { "id": 374, "name": 'Sundarbazar', "nepali": 'सुन्दरबजार' }
        ],
        [
          { "id": 375, "name": 'Aurahi', "nepali": 'औरही' },
          { "id": 376, "name": 'Balwa', "nepali": 'बलवा' },
          { "id": 377, "name": 'Bardibas', "nepali": 'बर्दिबास' },
          { "id": 378, "name": 'Bhangaha', "nepali": 'भँगाहा' },
          { "id": 379, "name": 'Ekdanra', "nepali": 'एकडारा' },
          { "id": 380, "name": 'Gaushala', "nepali": 'गौशाला' },
          { "id": 381, "name": 'Jaleswor', "nepali": 'जलेश्वर' },
          { "id": 382, "name": 'Loharpatti', "nepali": 'लोहरपट्टी' },
          { "id": 383, "name": 'Mahottari', "nepali": 'महोत्तरी' },
          { "id": 384, "name": 'Manra Siswa', "nepali": 'मनरा शिसवा' },
          { "id": 385, "name": 'Matihani', "nepali": 'मटिहानी' },
          { "id": 386, "name": 'Pipra', "nepali": 'पिपरा' },
          { "id": 387, "name": 'Ramgopalpur', "nepali": 'रामगोपालपुर' },
          { "id": 388, "name": 'Samsi', "nepali": 'साम्सी' },
          { "id": 389, "name": 'Sonama', "nepali": 'सोनमा' }
        ],
        [
          { "id": 390, "name": 'Bagmati', "nepali": 'वाग्मती' },
          { "id": 391, "name": 'Bakaiya', "nepali": 'बकैया' },
          { "id": 392, "name": 'Bhimphedi', "nepali": 'भिमफेदी' },
          {
            "id": 393,
            "name": 'Hetauda Sub-Metropolitian City',
            "nepali": 'हेटौडा'
          },
          { "id": 394, "name": 'Indrasarowar', "nepali": 'इन्द्रसरोवर' },
          { "id": 395, "name": 'Kailash', "nepali": 'कैलाश' },
          { "id": 396, "name": 'Makawanpurgadhi', "nepali": 'मकवानपुरगढी' },
          { "id": 397, "name": 'Manahari', "nepali": 'मनहरी' },
          { "id": 398, "name": 'Raksirang', "nepali": 'राक्सिराङ्ग' },
          { "id": 399, "name": 'Thaha', "nepali": 'थाहा' }
        ],
        [
          { "id": 400, "name": 'Chame', "nepali": 'चामे' },
          { "id": 401, "name": 'Manang Ingshyang', "nepali": 'मनाङ ङिस्याङ' },
          { "id": 402, "name": 'Narpa Bhumi', "nepali": 'नार्पा भूमि' },
          { "id": 403, "name": 'Narshon', "nepali": 'नासोँ' }
        ],
        [
          { "id": 404, "name": 'Belbari', "nepali": 'बेलवारी' },
          {
            "id": 405,
            "name": 'Biratnagar Metropolitian City',
            "nepali": 'विराटनगर'
          },
          { "id": 406, "name": 'Budhiganga', "nepali": 'बुढीगंगा' },
          { "id": 407, "name": 'Dhanpalthan', "nepali": 'धनपालथान' },
          { "id": 408, "name": 'Gramthan', "nepali": 'ग्रामथान' },
          { "id": 409, "name": 'Jahada', "nepali": 'जहदा' },
          { "id": 410, "name": 'Kanepokhari', "nepali": 'कानेपोखरी' },
          { "id": 411, "name": 'Katahari', "nepali": 'कटहरी' },
          { "id": 412, "name": 'Kerabari', "nepali": 'केराबारी' },
          { "id": 413, "name": 'Letang', "nepali": 'लेटाङ' },
          { "id": 414, "name": 'Miklajung', "nepali": 'मिक्लाजुङ' },
          { "id": 415, "name": 'Patahrishanishchare', "nepali": 'पथरी शनिश्चरे' },
          { "id": 416, "name": 'Rangeli', "nepali": 'रंगेली' },
          { "id": 417, "name": 'Ratuwamai', "nepali": 'रतुवामाई' },
          { "id": 418, "name": 'Sundarharaicha', "nepali": 'सुन्दरहरैंचा' },
          { "id": 419, "name": 'Sunwarshi', "nepali": 'सुनवर्षी' },
          { "id": 420, "name": 'Uralabari', "nepali": 'उर्लाबारी' }
        ],
        [
          { "id": 421, "name": 'Chhayanath Rara', "nepali": 'छायानाथ' },
          { "id": 422, "name": 'Khatyad', "nepali": 'खत्याङ' },
          { "id": 423, "name": 'Mugum Karmarong', "nepali": 'मुगुम कार्मारोग' },
          { "id": 424, "name": 'Soru', "nepali": 'सोरु' }
        ],
        [
          { "id": 425, "name": 'Gharapjhong', "nepali": 'घरपझोङ' },
          {
            "id": 426,
            "name": 'Lo-Ghekar Damodarkunda',
            "nepali": 'लो–घेकर दामोदरकुण्ड'
          },
          { "id": 427, "name": 'Lomanthang', "nepali": 'लोमन्थाङ' },
          { "id": 428, "name": 'Thasang', "nepali": 'थासाङ' },
          {
            "id": 429,
            "name": 'Waragung Muktikhsetra',
            "nepali": 'बारागुङ मुक्तिक्षेत्र'
          }
        ],
        [
          { "id": 430, "name": 'Annapurna', "nepali": 'अन्नपूर्ण' },
          { "id": 431, "name": 'Beni', "nepali": 'बेनी' },
          { "id": 432, "name": 'Dhaulagiri', "nepali": 'धवलागिरी' },
          { "id": 433, "name": 'Malika', "nepali": 'मालिका' },
          { "id": 434, "name": 'Mangala', "nepali": 'मंगला' },
          { "id": 435, "name": 'Raghuganga', "nepali": 'रघुगंगा' }
        ],
        [
          { "id": 436, "name": 'Baudeekali', "nepali": 'बौदीकाली' },
          { "id": 437, "name": 'Binayee Tribeni', "nepali": 'विनयीत्रिवेणी' },
          { "id": 438, "name": 'Bulingtar', "nepali": 'बुलिङटार' },
          { "id": 439, "name": 'Devchuli', "nepali": 'देवचुली' },
          { "id": 440, "name": 'Gaidakot', "nepali": 'गैंडाकोट' },
          { "id": 441, "name": 'Hupsekot', "nepali": 'हुप्सेकोट' },
          { "id": 442, "name": 'Kawasoti', "nepali": 'कावासोती' },
          { "id": 443, "name": 'Madhyabindu', "nepali": 'मध्यविन्दु' }
        ],
        [
          { "id": 444, "name": 'Bardaghat', "nepali": 'बर्दघाट' },
          { "id": 445, "name": 'Palhi Nandan', "nepali": 'पाल्हिनन्दन' },
          { "id": 446, "name": 'Pratappur', "nepali": 'प्रतापपुर' },
          { "id": 447, "name": 'Ramgram', "nepali": 'रामग्राम' },
          { "id": 448, "name": 'Sarawal', "nepali": 'सरावल' },
          { "id": 449, "name": 'Sunwal', "nepali": 'सुनवल' },
          { "id": 450, "name": 'Susta', "nepali": 'सुस्ता' }
        ],
        [
          { "id": 451, "name": 'Belkotgadhi', "nepali": 'बेलकोटगढी' },
          { "id": 452, "name": 'Bidur', "nepali": 'विदुर' },
          { "id": 453, "name": 'Dupcheshwar', "nepali": 'दुप्चेश्वर' },
          { "id": 454, "name": 'Kakani', "nepali": 'ककनी' },
          { "id": 455, "name": 'Kispang', "nepali": 'किस्पाङ' },
          { "id": 456, "name": 'Likhu', "nepali": 'लिखु' },
          { "id": 457, "name": 'Myagang', "nepali": 'म्यागङ' },
          { "id": 458, "name": 'Panchakanya', "nepali": 'पञ्चकन्या' },
          { "id": 459, "name": 'Shivapuri', "nepali": 'शिवपुरी' },
          { "id": 460, "name": 'Suryagadhi', "nepali": 'सूर्यगढी' },
          { "id": 461, "name": 'Tadi', "nepali": 'तादीगाउँ' },
          { "id": 462, "name": 'Tarkeshwar', "nepali": 'तारकेश्वर' }
        ],
        [
          { "id": 463, "name": 'Champadevi', "nepali": 'चम्पादेवी' },
          { "id": 464, "name": 'Chisankhugadhi', "nepali": 'चिशंखुगढी' },
          { "id": 465, "name": 'Khijidemba', "nepali": 'खिजीदेम्वा' },
          { "id": 466, "name": 'Likhu', "nepali": 'लिखु' },
          { "id": 467, "name": 'Manebhanjyang', "nepali": 'मानेभञ्ज्याङ' },
          { "id": 468, "name": 'Molung', "nepali": 'मोलुङ' },
          { "id": 469, "name": 'Siddhicharan', "nepali": 'सिद्धिचरण' },
          { "id": 470, "name": 'Sunkoshi', "nepali": 'सुनकोशी' }
        ],
        [
          { "id": 471, "name": 'Bagnaskali', "nepali": 'बगनासकाली' },
          { "id": 472, "name": 'Mathagadhi', "nepali": 'माथागढी' },
          { "id": 473, "name": 'Nisdi', "nepali": 'निस्दि' },
          { "id": 474, "name": 'Purbakhola', "nepali": 'पुर्वखोला' },
          { "id": 475, "name": 'Rainadevi Chhahara', "nepali": 'रैनादेवी छहरा' },
          { "id": 476, "name": 'Rambha', "nepali": 'रम्भा' },
          { "id": 477, "name": 'Rampur', "nepali": 'रामपुर' },
          { "id": 478, "name": 'Ribdikot', "nepali": 'रिब्दिकोट' },
          { "id": 479, "name": 'Tansen', "nepali": 'तानसेन' },
          { "id": 480, "name": 'Tinau', "nepali": 'तिनाउ' }
        ],
        [
          { "id": 481, "name": 'Falelung', "nepali": 'फालेलुङ' },
          { "id": 482, "name": 'Falgunanda', "nepali": 'फाल्गुनन्द' },
          { "id": 483, "name": 'Hilihang', "nepali": 'हिलिहाङ' },
          { "id": 484, "name": 'Kummayak', "nepali": 'कुम्मायक' },
          { "id": 485, "name": 'Miklajung', "nepali": 'मिक्लाजुङ' },
          { "id": 486, "name": 'Phidim', "nepali": 'फिदिम' },
          { "id": 487, "name": 'Tumbewa', "nepali": 'तुम्वेवा' },
          { "id": 488, "name": 'Yangwarak', "nepali": 'याङवरक' }
        ],
        [
          { "id": 489, "name": 'Bihadi', "nepali": 'विहादी' },
          { "id": 490, "name": 'Jaljala', "nepali": 'जलजला' },
          { "id": 491, "name": 'Kushma', "nepali": 'कुश्मा' },
          { "id": 492, "name": 'Mahashila', "nepali": 'महाशिला' },
          { "id": 493, "name": 'Modi', "nepali": 'मोदी' },
          { "id": 494, "name": 'Painyu', "nepali": 'पैयूं' },
          { "id": 495, "name": 'Phalebas', "nepali": 'फलेवास' }
        ],
        [
          { "id": 496, "name": 'Bahudaramai', "nepali": 'बहुदरमाई' },
          { "id": 497, "name": 'Bindabasini', "nepali": 'बिन्दबासिनी' },
          {
            "id": 498,
            "name": 'Birgunj Metropolitian City',
            "nepali": 'बिरगंजपोखरिया'
          },
          { "id": 499, "name": 'Chhipaharmai', "nepali": 'छिपहरमाई' },
          { "id": 500, "name": 'Dhobini', "nepali": 'धोबीनी' },
          { "id": 501, "name": 'Jagarnathpur', "nepali": 'जगरनाथपुर' },
          { "id": 502, "name": 'Jirabhawani', "nepali": 'जिराभवानी' },
          { "id": 503, "name": 'Kalikamai', "nepali": 'कालिकामाई' },
          { "id": 504, "name": 'Pakahamainpur', "nepali": 'पकाहा मैनापुर' },
          { "id": 505, "name": 'Parsagadhi', "nepali": 'पर्सागढी' },
          { "id": 506, "name": 'Paterwasugauli', "nepali": 'पटेर्वा सुगौली' },
          { "id": 507, "name": 'Pokhariya', "nepali": 'पोखरिया' },
          { "id": 508, "name": 'SakhuwaPrasauni', "nepali": 'सखुवा प्रसौनी' },
          { "id": 509, "name": 'Thori', "nepali": 'ठोरी' }
        ],
        [
          { "id": 510, "name": 'Ayirabati', "nepali": 'एरावती' },
          { "id": 511, "name": 'Gaumukhi', "nepali": 'गौमुखी' },
          { "id": 512, "name": 'Jhimruk', "nepali": 'झिमरुक' },
          { "id": 513, "name": 'Mallarani', "nepali": 'मल्लरानी' },
          { "id": 514, "name": 'Mandavi', "nepali": 'माण्डवी' },
          { "id": 515, "name": 'Naubahini', "nepali": 'नौबहिनी' },
          { "id": 516, "name": 'Pyuthan', "nepali": 'प्युठान' },
          { "id": 517, "name": 'Sarumarani', "nepali": 'सरुमारानी' },
          { "id": 518, "name": 'Sworgadwary', "nepali": 'स्वर्गद्वारी' }
        ],
        [
          { "id": 519, "name": 'Doramba', "nepali": 'दोरम्बा' },
          { "id": 520, "name": 'Gokulganga', "nepali": 'गोकुलगङ्गा' },
          { "id": 521, "name": 'Khadadevi', "nepali": 'खाँडादेवी' },
          { "id": 522, "name": 'Likhu Tamakoshi', "nepali": 'लिखु तामाकोशी' },
          { "id": 523, "name": 'Manthali', "nepali": 'मन्थली' },
          { "id": 524, "name": 'Ramechhap', "nepali": 'रामेछाप' },
          { "id": 525, "name": 'Sunapati', "nepali": 'सुनापती' },
          { "id": 526, "name": 'Umakunda', "nepali": 'उमाकुण्ड' }
        ],
        [
          { "id": 527, "name": 'Amachodingmo', "nepali": 'आमाछोदिङमो' },
          { "id": 528, "name": 'Gosaikunda', "nepali": 'गोसाईकुण्ड' },
          { "id": 529, "name": 'Kalika', "nepali": 'कालिका' },
          { "id": 530, "name": 'Naukunda', "nepali": 'नौकुण्ड' },
          { "id": 531, "name": 'Uttargaya', "nepali": 'उत्तरगया' }
        ],
        [
          { "id": 532, "name": 'Baudhimai', "nepali": 'बौधीमाई' },
          { "id": 533, "name": 'Brindaban', "nepali": 'बृन्दावन' },
          { "id": 534, "name": 'Chandrapur', "nepali": 'चन्द्रपुर' },
          { "id": 535, "name": 'Dewahhi Gonahi', "nepali": 'देवाही गोनाही' },
          { "id": 536, "name": 'Durga Bhagwati', "nepali": 'दुर्गा भगवती' },
          { "id": 537, "name": 'Gadhimai', "nepali": 'गढीमाई' },
          { "id": 538, "name": 'Garuda', "nepali": 'गरुडा' },
          { "id": 539, "name": 'Gaur', "nepali": 'गौर' },
          { "id": 540, "name": 'Gujara', "nepali": 'गुजरा' },
          { "id": 541, "name": 'Ishanath', "nepali": 'ईशनाथ' },
          { "id": 542, "name": 'Katahariya', "nepali": 'कटहरिया' },
          { "id": 543, "name": 'Madhav Narayan', "nepali": 'माधव नारायण' },
          { "id": 544, "name": 'Maulapur', "nepali": 'मौलापुर' },
          { "id": 545, "name": 'Paroha', "nepali": 'परोहा' },
          { "id": 546, "name": 'Phatuwa Bijayapur', "nepali": 'फतुबाबिजयपुर' },
          { "id": 547, "name": 'Rajdevi', "nepali": 'राजदेवी' },
          { "id": 548, "name": 'Rajpur', "nepali": 'राजपुर' },
          { "id": 549, "name": 'Yemunamai', "nepali": 'यमुनामाई' }
        ],
        [
          { "id": 550, "name": 'Gangadev', "nepali": 'गंगादेव' },
          { "id": 551, "name": 'Lungri', "nepali": 'लुङग्री' },
          { "id": 552, "name": 'Madi', "nepali": 'माडी' },
          { "id": 553, "name": 'Pariwartan', "nepali": 'परिवर्तन ' },
          { "id": 554, "name": 'Rolpa', "nepali": 'रोल्पा' },
          { "id": 555, "name": 'Runtigadi', "nepali": 'रुन्टीगढी' },
          { "id": 556, "name": 'Sunchhahari', "nepali": 'सुनछहरी' },
          { "id": 557, "name": 'Sunil Smriti', "nepali": 'सुनिल स्मृति ' },
          { "id": 558, "name": 'Thawang', "nepali": 'थबाङ ' },
          { "id": 559, "name": 'Tribeni', "nepali": 'त्रिवेणीमाडी' }
        ],
        [
          { "id": 560, "name": 'Bhume', "nepali": 'भूमे' },
          { "id": 561, "name": 'Putha Uttarganga', "nepali": 'पुथ उत्तरगँगा' },
          { "id": 562, "name": 'Sisne', "nepali": 'सिस्ने' }
        ],
        [
          { "id": 563, "name": 'Aathbiskot', "nepali": 'अठबिसकोट' },
          { "id": 564, "name": 'Banfikot', "nepali": 'बाँफिकोट' },
          { "id": 565, "name": 'Chaurjahari', "nepali": 'चौरजहारी' },
          { "id": 566, "name": 'Musikot', "nepali": 'मुसिकोट' },
          { "id": 567, "name": 'Sani Bheri', "nepali": 'सानीभेरी' },
          { "id": 568, "name": 'Tribeni', "nepali": 'त्रिवेणी' }
        ],
        [
          { "id": 569, "name": 'Butwal Sub-Metropolitian City', "nepali": 'बुटवल' },
          { "id": 570, "name": 'Devdaha', "nepali": 'देवदह' },
          { "id": 571, "name": 'Gaidahawa', "nepali": 'गैडहवा' },
          { "id": 572, "name": 'Kanchan', "nepali": 'कन्चन' },
          { "id": 573, "name": 'Kotahimai', "nepali": 'कोटहीमार्इ' },
          {
            "id": 574,
            "name": 'Lumbini Sanskritik',
            "nepali": 'लुम्बिनी सांस्कृतिक'
          },
          { "id": 575, "name": 'Marchawari', "nepali": 'मर्चवारी' },
          { "id": 576, "name": 'Mayadevi', "nepali": 'मायादेवी' },
          { "id": 577, "name": 'Omsatiya', "nepali": 'ओमसतिया' },
          { "id": 578, "name": 'Rohini', "nepali": 'रोहिणी' },
          { "id": 579, "name": 'Sainamaina', "nepali": 'सैनामैना' },
          { "id": 580, "name": 'Sammarimai', "nepali": 'सम्मरीमार्इ' },
          { "id": 581, "name": 'Siddharthanagar', "nepali": 'सिद्धार्थनगर' },
          { "id": 582, "name": 'Siyari', "nepali": 'सियारी' },
          { "id": 583, "name": 'Sudhdhodhan', "nepali": 'सुद्धोधन' },
          { "id": 584, "name": 'Tillotama', "nepali": 'तिलोत्तमा' }
        ],
        [
          { "id": 585, "name": 'Bagchaur', "nepali": 'बागचौर' },
          { "id": 586, "name": 'Bangad Kupinde', "nepali": 'बनगाड ' },
          { "id": 587, "name": 'Chhatreshwori', "nepali": 'छत्रेश्वरी' },
          { "id": 588, "name": 'Darma', "nepali": 'दार्मा' },
          { "id": 589, "name": 'Kalimati', "nepali": 'कालीमाटी' },
          { "id": 590, "name": 'Kapurkot', "nepali": 'कपुरकोट' },
          { "id": 591, "name": 'Kumakh', "nepali": 'कुमाख ' },
          { "id": 592, "name": 'Sharada', "nepali": 'सारदा' },
          { "id": 593, "name": 'Siddha Kumakh', "nepali": 'सिद्ध कुमाख' },
          { "id": 594, "name": 'Tribeni', "nepali": 'त्रिवेणी' }
        ],
        [
          { "id": 595, "name": 'Bhotkhola', "nepali": 'भोटखोला' },
          { "id": 596, "name": 'Chainpur', "nepali": 'चैनपुर' },
          { "id": 597, "name": 'Chichila', "nepali": 'चिचिला' },
          { "id": 598, "name": 'Dharmadevi', "nepali": 'धर्मदेवी' },
          { "id": 599, "name": 'Khandbari', "nepali": 'खाँदवारी' },
          { "id": 600, "name": 'Madi', "nepali": 'मादी' },
          { "id": 601, "name": 'Makalu', "nepali": 'मकालु' },
          { "id": 602, "name": 'Panchakhapan', "nepali": 'पाँचखपन' },
          { "id": 603, "name": 'Sabhapokhari', "nepali": 'सभापोखरी' },
          { "id": 604, "name": 'Silichong', "nepali": 'सिलीचोङ' }
        ],
        [
          {
            "id": 605,
            "name": 'Agnisair Krishna Savaran',
            "nepali": 'अग्नीसाइर कृष्णासवरन'
          },
          { "id": 606, "name": 'Balan Bihul', "nepali": 'बलान विहुल ' },
          { "id": 607, "name": 'Bishnupur', "nepali": 'बिष्णुपुर ' },
          { "id": 608, "name": 'Bode Barsain', "nepali": 'बोदेबरसाइन ' },
          { "id": 609, "name": 'Chhinnamasta', "nepali": 'छिन्नमस्ता ' },
          { "id": 610, "name": 'Dakneshwori', "nepali": 'डाक्नेश्वरी' },
          {
            "id": 611,
            "name": 'Hanumannagar Kankalini',
            "nepali": 'हनुमाननगर कंकालिनी '
          },
          { "id": 612, "name": 'Kanchanrup', "nepali": 'कञ्चनरुप' },
          { "id": 613, "name": 'Khadak', "nepali": 'खडक' },
          { "id": 614, "name": 'Mahadeva', "nepali": 'महादेवा' },
          { "id": 615, "name": 'Rajbiraj', "nepali": 'राजबिराज ' },
          { "id": 616, "name": 'Rajgadh', "nepali": 'राजगढ ' },
          { "id": 617, "name": 'Rupani', "nepali": 'रुपनी' },
          { "id": 618, "name": 'Saptakoshi', "nepali": 'सप्तकोशी' },
          { "id": 619, "name": 'Shambhunath', "nepali": 'शम्भुनाथ ' },
          { "id": 620, "name": 'Surunga', "nepali": 'सुरुङ्गा ' },
          { "id": 621, "name": 'Tilathi Koiladi', "nepali": 'तिलाठी कोईलाडी' },
          { "id": 622, "name": 'Tirahut', "nepali": 'तिरहुत' }
        ],
        [
          { "id": 623, "name": 'Bagmati', "nepali": 'बागमती' },
          { "id": 624, "name": 'Balara', "nepali": 'बलरा' },
          { "id": 625, "name": 'Barahathawa', "nepali": 'बरहथवा' },
          { "id": 626, "name": 'Basbariya', "nepali": 'बसबरिया' },
          { "id": 627, "name": 'Bishnu', "nepali": 'विष्णु' },
          { "id": 628, "name": 'Bramhapuri', "nepali": 'ब्रम्हापुरी' },
          { "id": 629, "name": 'Chakraghatta', "nepali": 'चक्रघट्टा' },
          { "id": 630, "name": 'Chandranagar', "nepali": 'चन्द्रनगर' },
          { "id": 631, "name": 'Dhankaul', "nepali": 'धनकौल' },
          { "id": 632, "name": 'Godaita', "nepali": 'गोडैटा' },
          { "id": 633, "name": 'Haripur', "nepali": 'हरिपुर' },
          { "id": 634, "name": 'Haripurwa', "nepali": 'हरिपुर्वा' },
          { "id": 635, "name": 'Hariwan', "nepali": 'हरिवन' },
          { "id": 636, "name": 'Ishworpur', "nepali": 'ईश्वरपुर' },
          { "id": 637, "name": 'Kabilasi', "nepali": 'कविलासी' },
          { "id": 638, "name": 'Kaudena', "nepali": 'कौडेना' },
          { "id": 639, "name": 'Lalbandi', "nepali": 'लालबन्दी' },
          { "id": 640, "name": 'Malangawa', "nepali": 'मलंगवा' },
          { "id": 641, "name": 'Parsa', "nepali": 'पर्सा' },
          { "id": 642, "name": 'Ramnagar', "nepali": 'रामनगर' }
        ],
        [
          { "id": 643, "name": 'Dudhouli', "nepali": 'दुधौली' },
          { "id": 644, "name": 'Ghanglekh', "nepali": 'घ्याङखेल' },
          { "id": 645, "name": 'Golanjor', "nepali": 'गोलन्जोर' },
          { "id": 646, "name": 'Hariharpurgadhi', "nepali": ' हरिहरपुरगढी' },
          { "id": 647, "name": 'Kamalamai', "nepali": 'कमलामाई' },
          { "id": 648, "name": 'Marin', "nepali": 'मरिण' },
          { "id": 649, "name": 'Phikkal', "nepali": 'फिक्कल' },
          { "id": 650, "name": 'Sunkoshi', "nepali": 'सुनकोशी' },
          { "id": 651, "name": 'Tinpatan', "nepali": 'तीनपाटन' }
        ],
        [
          { "id": 652, "name": 'Balefi', "nepali": 'बलेफी' },
          { "id": 653, "name": 'Barhabise', "nepali": 'वाह्रविसे ' },
          { "id": 654, "name": 'Bhotekoshi', "nepali": 'भोटेकोशी' },
          {
            "id": 655,
            "name": 'Chautara SangachokGadhi',
            "nepali": 'चौतारा साँगाचोकगढी '
          },
          { "id": 656, "name": 'Helambu', "nepali": 'हेलम्बु' },
          { "id": 657, "name": 'Indrawati', "nepali": 'इन्द्रावती' },
          { "id": 658, "name": 'Jugal', "nepali": 'जुगल' },
          { "id": 659, "name": 'Lisangkhu Pakhar', "nepali": 'लिसंखु पाखर' },
          { "id": 660, "name": 'Melamchi', "nepali": 'मेलम्ची' },
          {
            "id": 661,
            "name": 'Panchpokhari Thangpal',
            "nepali": 'पाँचपोखरी थाङपाल'
          },
          { "id": 662, "name": 'Sunkoshi', "nepali": 'सुनकोशी' },
          { "id": 663, "name": 'Tripurasundari', "nepali": 'त्रिपुरासन्दरी' }
        ],
        [
          { "id": 664, "name": 'Arnama', "nepali": 'अर्नमा' },
          { "id": 665, "name": 'Aurahi', "nepali": 'औरही' },
          { "id": 666, "name": 'Bariyarpatti', "nepali": 'बरियारपट्टी' },
          { "id": 667, "name": 'Bhagawanpur', "nepali": 'भगवानपुर' },
          { "id": 668, "name": 'Bishnupur', "nepali": 'बिष्णुपुर' },
          { "id": 669, "name": 'Dhangadhimai', "nepali": 'धनगढीमाई' },
          { "id": 670, "name": 'Golbazar', "nepali": 'गोलबजार' },
          { "id": 671, "name": 'Kalyanpur', "nepali": 'कल्याणपुर' },
          { "id": 672, "name": 'Karjanha', "nepali": 'कर्जन्हा' },
          { "id": 673, "name": 'Lahan', "nepali": 'लहान' },
          { "id": 674, "name": 'Laxmipur Patari', "nepali": 'लक्ष्मीपुर पतारी' },
          { "id": 675, "name": 'Mirchaiya', "nepali": 'मिर्चैया' },
          { "id": 676, "name": 'Naraha', "nepali": 'नरहा' },
          { "id": 677, "name": 'Nawarajpur', "nepali": 'नवराजपुर' },
          {
            "id": 678,
            "name": 'Sakhuwanankarkatti',
            "nepali": 'सखुवा नान्कारकट्टी'
          },
          { "id": 679, "name": 'Siraha', "nepali": 'सिरहा' },
          { "id": 680, "name": 'Sukhipur', "nepali": 'सुखीपुर' }
        ],
        [
          {
            "id": 681,
            "name": 'Khumbupasanglahmu',
            "nepali": 'खुम्बु पासाङल्हामु'
          },
          { "id": 682, "name": 'Likhupike', "nepali": 'लिखु पिके' },
          { "id": 683, "name": 'Maapya Dudhkoshi', "nepali": 'माप्य दुधकोशी' },
          { "id": 684, "name": 'Mahakulung', "nepali": 'महाकुलुङ' },
          { "id": 685, "name": 'Nechasalyan', "nepali": 'नेचासल्यान' },
          { "id": 686, "name": 'Solududhakunda', "nepali": 'सोलुदुधकुण्ड' },
          { "id": 687, "name": 'Sotang', "nepali": 'सोताङ' },
          { "id": 688, "name": 'Thulung Dudhkoshi', "nepali": 'थुलुङ दुधकोशी' }
        ],
        [
          { "id": 689, "name": 'Barahchhetra', "nepali": 'बराह क्षेत्र' },
          { "id": 690, "name": 'Barju', "nepali": 'बर्जु' },
          { "id": 691, "name": 'Bhokraha Narsing', "nepali": 'भोक्राहा नरसिंह' },
          { "id": 692, "name": 'Dewanganj', "nepali": 'देवानगञ्ज' },
          { "id": 693, "name": 'Dharan Sub-Metropolitian City', "nepali": 'धरान' },
          { "id": 694, "name": 'Duhabi', "nepali": 'दुहवी' },
          { "id": 695, "name": 'Gadhi', "nepali": 'गढी' },
          { "id": 696, "name": 'Harinagar', "nepali": 'हरिनगर ' },
          { "id": 697, "name": 'Inaruwa', "nepali": 'इनरुवा' },
          {
            "id": 698,
            "name": 'Itahari Sub-Metropolitian City',
            "nepali": 'ईटहरी '
          },
          { "id": 699, "name": 'Koshi', "nepali": 'कोशी' },
          { "id": 700, "name": 'Ramdhuni', "nepali": 'रामधुनी' }
        ],
        [
          { "id": 701, "name": 'Barahtal', "nepali": 'बराहताल' },
          { "id": 702, "name": 'Bheriganga', "nepali": 'भेरिगंगा' },
          { "id": 703, "name": 'Birendranagar', "nepali": 'बीरेन्द्रनगर' },
          { "id": 704, "name": 'Chaukune', "nepali": 'चौकुने' },
          { "id": 705, "name": 'Chingad', "nepali": 'चिङ्गाड' },
          { "id": 706, "name": 'Gurbhakot', "nepali": 'गुर्भाकोट' },
          { "id": 707, "name": 'Lekbeshi', "nepali": 'लेकवेशी' },
          { "id": 708, "name": 'Panchpuri', "nepali": 'पञ्चपुरी' },
          { "id": 709, "name": 'Simta', "nepali": 'सिम्ता' }
        ],
        [
          { "id": 710, "name": 'Aandhikhola', "nepali": 'आँधिखोला' },
          { "id": 711, "name": 'Arjunchaupari', "nepali": 'अर्जुनचौपारी' },
          { "id": 712, "name": 'Bhirkot', "nepali": 'भीरकोट' },
          { "id": 713, "name": 'Biruwa', "nepali": 'बिरुवा' },
          { "id": 714, "name": 'Chapakot', "nepali": 'चापकोट' },
          { "id": 715, "name": 'Galyang', "nepali": 'गल्याङ ' },
          { "id": 716, "name": 'Harinas', "nepali": 'हरिनास' },
          { "id": 717, "name": 'Kaligandagi', "nepali": 'कालीगण्डकी' },
          { "id": 718, "name": 'Phedikhola', "nepali": 'फेदीखोला' },
          { "id": 719, "name": 'Putalibazar', "nepali": 'पुतलीबजार ' },
          { "id": 720, "name": 'Waling', "nepali": 'वालिङ' }
        ],
        [
          { "id": 721, "name": 'Anbukhaireni', "nepali": 'आँबुखैरेनी' },
          { "id": 722, "name": 'Bandipur', "nepali": 'बन्दिपुर' },
          { "id": 723, "name": 'Bhanu', "nepali": 'भानु' },
          { "id": 724, "name": 'Bhimad', "nepali": 'भिमाद' },
          { "id": 725, "name": 'Byas', "nepali": 'व्यास' },
          { "id": 726, "name": 'Devghat', "nepali": 'देवघाट' },
          { "id": 727, "name": 'Ghiring', "nepali": 'घिरिङ' },
          { "id": 728, "name": 'Myagde', "nepali": 'म्याग्दे' },
          { "id": 729, "name": 'Rhishing', "nepali": 'ऋषिङ' },
          { "id": 730, "name": 'Shuklagandaki', "nepali": 'शुक्लागण्डकी' }
        ],
        [
          { "id": 731, "name": 'Aathrai Tribeni', "nepali": 'आठराई त्रिवेणी' },
          { "id": 732, "name": 'Maiwakhola', "nepali": 'मैवाखोला' },
          { "id": 733, "name": 'Meringden', "nepali": 'मेरिङदेन' },
          { "id": 734, "name": 'Mikwakhola', "nepali": 'मिक्वाखोला' },
          { "id": 735, "name": 'Pathivara Yangwarak', "nepali": 'पाथिभरा याङवरक ' },
          { "id": 736, "name": 'Phaktanglung', "nepali": 'फक्त्ताङलुङ' },
          { "id": 737, "name": 'Phungling', "nepali": 'फुङ्लिङ' },
          { "id": 738, "name": 'Sidingba', "nepali": 'सिदिङ्वा' },
          { "id": 739, "name": 'Sirijangha', "nepali": 'सिरीजङ्घा' }
        ],
        [
          { "id": 740, "name": 'Aathrai', "nepali": 'आठराई ' },
          { "id": 741, "name": 'Chhathar', "nepali": 'छथर' },
          { "id": 742, "name": 'Laligurans', "nepali": 'लालीगुराँस' },
          { "id": 743, "name": 'Menchayam', "nepali": 'मेन्छयायेम' },
          { "id": 744, "name": 'Myanglung', "nepali": 'म्याङलुङ' },
          { "id": 745, "name": 'Phedap', "nepali": 'फेदाप' }
        ],
        [
          { "id": 746, "name": 'Belaka', "nepali": 'वेलका' },
          { "id": 747, "name": 'Chaudandigadhi', "nepali": 'चौदण्डीगढी' },
          { "id": 748, "name": 'Katari', "nepali": 'कटारी' },
          { "id": 749, "name": 'Limchungbung', "nepali": 'लिम्चुङबुङ' },
          { "id": 750, "name": 'Rautamai', "nepali": 'रौतामाई' },
          { "id": 751, "name": 'Tapli', "nepali": 'ताप्ली' },
          { "id": 752, "name": 'Triyuga', "nepali": 'त्रियुगा' },
          { "id": 753, "name": 'Udayapurgadhi', "nepali": 'उदयपुरगढी' }
        ]
      ],
      relationList: [{"id":1,"name":"हजुरबुवा "},{"id":2,"name":"हजुरआमा"},{"id":3,"name":"बावु"},{"id":4,"name":"आमा  "},{"id":5,"name":"छोरा  "},{"id":6,"name":"छोरी"},{"id":7,"name":"ठूलो बुवा"},{"id":8,"name":"ठुलो आमा"},{"id":9,"name":"काका"},{"id":10,"name":"काकी"},{"id":11,"name":"भतिज"},{"id":12,"name":"भतिजी"},{"id":13,"name":"दाजु "},{"id":14,"name":"भाइ"},{"id":15,"name":"दिदी  "},{"id":16,"name":"बहिनी"},{"id":17,"name":"मामा"},{"id":18,"name":"माइजु"},{"id":19,"name":"भान्जा "},{"id":20,"name":"भान्जी"},{"id":21,"name":"श्रीमान  "},{"id":22,"name":"श्रीमती"},{"id":23,"name":"ज्वाई "},{"id":24,"name":"छोरी"},{"id":25,"name":"सासु  "},{"id":26,"name":"ससुरा"},{"id":27,"name":"दाजु "},{"id":28,"name":"भाउजु"},{"id":29,"name":"भाइ "},{"id":30,"name":"वुहारी"},{"id":31,"name":"ग्लफ्रेन्ड "},{"id":32,"name":"व्योफ्रन्ड"}],
      wardList: [{"id":1,"name":"1"},{"id":2,"name":"2"},{"id":3,"name":"3"},{"id":4,"name":"4"},{"id":5,"name":"5"},{"id":6,"name":"6"},{"id":7,"name":"7"},{"id":8,"name":"8"},{"id":9,"name":"9"},{"id":10,"name":"10"},{"id":11,"name":"11"},{"id":12,"name":"12"},{"id":13,"name":"13"},{"id":14,"name":"14"},{"id":15,"name":"15"},{"id":16,"name":"16"},{"id":17,"name":"17"},{"id":18,"name":"18"},{"id":19,"name":"19"},{"id":20,"name":"20"},{"id":21,"name":"21"},{"id":22,"name":"22"},{"id":23,"name":"23"},{"id":24,"name":"24"},{"id":25,"name":"25"},{"id":26,"name":"26"},{"id":27,"name":"27"},{"id":28,"name":"28"},{"id":29,"name":"29"},{"id":30,"name":"30"},{"id":31,"name":"31"},{"id":32,"name":"32"},{"id":33,"name":"33"},{"id":34,"name":"34"},{"id":35,"name":"35"},{"id":36,"name":"36"},{"id":37,"name":"37"},{"id":38,"name":"38"},{"id":39,"name":"39"},{"id":40,"name":"40"},{"id":41,"name":"41"},{"id":42,"name":"42"},{"id":43,"name":"43"},{"id":44,"name":"44"},{"id":45,"name":"45"},{"id":46,"name":"46"},{"id":47,"name":"47"},{"id":48,"name":"48"},{"id":49,"name":"49"},{"id":50,"name":"50"}],
    };
  },
  validations: {
    form: {
    //   verification_token: {
    //     required,
    //   },
    //   verifiedBy: {
    //     required
    //   },
      nepali_name: {
        required,
      }, 
            english_name: {
        required,
      }, 
            gender: {
        required,
      }, 
            citizenship_number: {
        required,
      }, 
            birth_date: {
        required,
      }, 
      birth_date_eng: {
        required,
      },
            father_name: {
        required,
      }, 
            grandfather_name: {
        required,
      }, 
            district: {
        required,
      }, district_eng: {
        required,
      }, 
            mobile_number: {
        required,
      }, 
            phone_number: {
        required,
      }, 
            permanent_address: {
        required,
      }, 
      permanent_address_eng:{
        required,
      },
            current_address: {
        required,
      }, 
      current_address_eng: {
        required,
      },
            temporary_address: {
        required,
      },
      temporary_address_eng: {
        required,
      }, 
            bank: {
        // required,
      }, 
            account_number: {
        // required,
      }, 
            beneficiary_name: {
        required,
      }, 
      beneficiary_name_eng: {
        required,
      },
            relationship: {
        required,
      }, 
            beneficiary_contact: {
        required,
      }, 
      registration_date: {
        required,
      },
      registration_date_eng: {
        required,
      },
    //         registration_date: {
    //     required,
    //   }, 
            referred_by: {
        required,
      }, 
      referred_by_eng: {
        required,
      },
      citizenship_date: {
        required,
      },
      citizenship_date_eng: {
        required,
      },

      beneficiary_address: {
        required,
      },

      voucher_deposit_date: {
        required,
      },
      voucher_deposit_date_eng:{
        required,
      },

      receipt_no: {
        required,
      },

      receipt_date: {
        required,
      },
      receipt_date_eng: {
        required,
      },
      municipality: {
        required,
      },
      municipality_eng: {
        required,
      },
      form_status: {
        // required,
      },
      // card_status: {
      //   required,
      // },
      form_date: {
        // required
      },
      form_date_one:{

      },
      ward_eng: {
        required,
      },
      ward: {
        required,
      },
    //         entry_by: {
    //     required,
    //   }, 
    //         fingerprint_left: {
    //     required,
    //   }, 
    //         fingerprint_right: {
    //     required,
    //   }, 
      // isVerified: {
      //   required,
      // },
      // startDate: {
      //   required,
      // },
      // endDate: {
      //   required,
      // },
      // subjects: {
      //   required,
      // },
      form_scan: {
        // required,
      },
      photo_scan: {
        // required,
      },
      citizenship_scan_front: {
        // required,
      },
      citizenship_scan_back: {
        // required,
      },
      voucher_scan: {
        // required,
      },
      hakwala_scan: {
        // required,
      },
      fingerprint_left: {
        // required,
      },
      fingerprint_right: {
        // required,
      },
      signature_scan: {
        // required,
      },
      last_modified_by: {
        required
      },
      last_modified: {
        required
      }
    },
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    selectedCitizen: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isFormInvalid() {
      return this.$v.form.$invalid;
    },
    formScanLabel() {
      return !this.formScan ? 'Upload Form' : 'Another form scan';
    },
    photoScanLabel() {
      return !this.photoScan ? 'Upload Photo' : 'Another photo scan';
    },
    formCitizenshipLabel1() {
      return !this.citizenshipScan1 ? 'Upload Front' : 'Another Front';
    },
    formCitizenshipLabel2() {
      return !this.citizenshipScan2 ? 'Upload Back' : 'Another Back';
    },
    formVoucherLabel() {
      return !this.voucherScan ? 'Upload Voucher' : 'Another voucher scan';
    },
    formHakwalaLabel() {
      return !this.hakwalaScan ? 'Upload Hakwala' : 'Another hakwala scan';
    },
    formFingerprintLabel1() {
      return !this.fingerprintScan1 ? 'Fingerprint Left' : 'Another fingerprint';
    },
    formFingerprintLabel2() {
      return !this.fingerprintScan2 ? 'Fingerprint right' : 'Another fingerprint';
    },
    buttonLabel() {
      return !this.file ? 'Pick a file' : 'Pick another file';
    },
    formSignatureLabel() {
      return !this.signatureScan ? 'Signature' : 'Another Signature';
    },
    citizens() {
      return this.$store.state.citizens.items;
    },
  },

  mounted() {},
  created() {
     this.name = this.$store.state.auth.user.name;
  },
  methods: {
    bankSelection(val){
      if(typeof val.name != 'undefined'){
        this.form.bank = val.nepali;
      }
    },
    districtSelection(val){
      if(typeof val.name != 'undefined'){
        this.form.district = val.nepali;
        this.form.district_eng = val.name;
        this.municipalityOptions = this.municipality[val.id];
      }
    },
    municipalitySelection(val){
      if(typeof val.name != 'undefined'){
        this.form.municipality = val.nepali;
        this.form.municipality_eng = val.name;
      }
    },
    relationSelection(val){
      if(typeof val.name != 'undefined'){
        this.form.relationship = val.name;
      }
    },
    wardSelection(val){
      if(typeof val.name != 'undefined'){
        this.form.ward_eng = val.name;
        this.form.ward = nepalify.format(val.name);
      }
    },
    convertNepali(val){
      this.form[val] = preeti2.setUnicodePreeti(this.form[val]);
    },
    convertName(val){
       this.form.full_name = preeti2.setUnicodePreeti(this.form.full_name);
    },
    getDropdownValues(keyowrd){
      //refresh options
    },
    convertFatherName(val){
       this.form.father_name = preeti2.setUnicodePreeti(this.form.father_name);
    },
    convertGrandfatherName(val){
      this.form.grandfather_name = preeti2.setUnicodePreeti(this.form.grandfather_name);
    },
    convertCitizen(e) {
      this.form.citizenship_number = preeti2.setUnicodePreetiModified(this.form.citizenship_number);
    },
    convertAccountNumber(e){
      this.form.account_number = preeti2.setUnicodePreetiModified(this.form.account_number);
    },
    isLetterOrNumber(e) {
            let char = String.fromCharCode(e.keyCode);
            if (/^[0-9/-]+$/.test(char)) return true;
            else e.preventDefault();
    },
    assignDates(e, nepali, english, type){
      if (type === 1){
        let f = new Date(e);
        let a = NepaliDate.fromAD(f);
        this.form[nepali] = a.format('YYYY-MM-DD');
      } else {
        let a = new NepaliDate(e);
        let ad = a.getAD();
        let y = ad.month + 1;
        y = y < 10 ? '0'+y : y;
        this.form[english] = ad.year +'-'+ y +'-'+ ad.date;
      }
    },
    changeDateSelection(e){
      this[e]= this[e] == 0 ? 1 :0;
    },
    
    updateCitizenPressed() {
      // console.log(this.form);
      // console.log(this.form.verifiedBy)
      this.$v.form.$touch();

      let images_arr = ['form_scan','photo_scan','citizenship_scan_front','citizenship_scan_back','voucher_scan','hakwala_scan','fingerprint_left', 'fingerprint_right', 'signature_scan']
      images_arr.forEach(element => {
        if(!this.form[element] || this.form[element].length === 0){
          delete this.form[element];
        }
      });

      this.$store
        .dispatch('citizens/updateCitizenWithId', this.form)
        .then(() => {
          this.isOpen = false;

          // this.form = {};
          this.uploadPercent = 0;

          this.$buefy.snackbar.open({
            message: 'User Updated Successfully',
            queue: false,
          });
        })
        .catch((err) => {
          this.$buefy.snackbar.open({
            message: `${err.response.data.message}`,
            queue: false,
          });
        });
    },
    
    uploadForm(formScan) {
      this.isUploading = true;
      this.$emit('input', formScan);
      this.uploadPercent = 0;

      let formData = new FormData();

      formData.append('image', formScan);

      axiosInstance
        .post(`${getAPIEndpoint()}/citizens/image-upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: this.progressEvent,
        })
        .then((res) => {
          this.form.form_scan = res.data.imageUrl;
          this.isUploading = false;
        })
        .catch((err) => {
          this.isUploading = false;
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },

    uploadPhoto(photoScan) {
      this.isUploading = true;
      this.$emit('input', photoScan);
      this.uploadPercent = 0;

      let formData = new FormData();

      formData.append('image', photoScan);

      axiosInstance
        .post(`${getAPIEndpoint()}/citizens/image-upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: this.progressEvent,
        })
        .then((res) => {
          this.form.photo_scan = res.data.imageUrl;
          this.isUploading = false;
        })
        .catch((err) => {
          this.isUploading = false;
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },

    uploadCitizenship1(citizenshipScan1) {
      this.isUploading = true;
      this.$emit('input', citizenshipScan1);
      this.uploadPercent = 0;

      let formData = new FormData();

      formData.append('image', citizenshipScan1);

      axiosInstance
        .post(`${getAPIEndpoint()}/citizens/image-upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: this.progressEvent,
        })
        .then((res) => {
          this.form.citizenship_scan_front = res.data.imageUrl;
          this.isUploading = false;
        })
        .catch((err) => {
          this.isUploading = false;
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },

    uploadCitizenship2(citizenshipScan2) {
      this.isUploading = true;
      this.$emit('input', citizenshipScan2);
      this.uploadPercent = 0;

      let formData = new FormData();

      formData.append('image', citizenshipScan2);

      axiosInstance
        .post(`${getAPIEndpoint()}/citizens/image-upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: this.progressEvent,
        })
        .then((res) => {
          this.form.citizenship_scan_back = res.data.imageUrl;
        })
        .catch((err) => {
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },

    uploadVoucher(voucherScan) {
      this.isUploading = true;
      this.$emit('input', voucherScan);
      this.uploadPercent = 0;

      let formData = new FormData();

      formData.append('image', voucherScan);

      axiosInstance
        .post(`${getAPIEndpoint()}/citizens/image-upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: this.progressEvent,
        })
        .then((res) => {
          this.form.voucher_scan = res.data.imageUrl;
          this.isUploading = false;
        })
        .catch((err) => {
          this.isUploading = false;
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },

    uploadHakwala(hakwalaScan) {
      this.isUploading = true;
      this.$emit('input', hakwalaScan);
      this.uploadPercent = 0;

      let formData = new FormData();

      formData.append('image', hakwalaScan);

      axiosInstance
        .post(`${getAPIEndpoint()}/citizens/image-upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: this.progressEvent,
        })
        .then((res) => {
          this.form.hakwala_scan = res.data.imageUrl;
          this.isUploading = false;
        })
        .catch((err) => {
          this.isUploading = false;
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },

    uploadFingerprint1(fingerprintScan1) {
      this.isUploading = true;
      this.$emit('input', fingerprintScan1);
      this.uploadPercent = 0;

      let formData = new FormData();

      formData.append('image', fingerprintScan1);

      axiosInstance
        .post(`${getAPIEndpoint()}/citizens/image-upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: this.progressEvent,
        })
        .then((res) => {
          this.form.fingerprint_left = res.data.imageUrl;
          this.isUploading = false;
        })
        .catch((err) => {
          this.isUploading = false;
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },

    uploadFingerprint2(fingerprintScan2) {
      this.isUploading = true;
      this.$emit('input', fingerprintScan2);
      this.uploadPercent = 0;

      let formData = new FormData();

      formData.append('image', fingerprintScan2);

      axiosInstance
        .post(`${getAPIEndpoint()}/citizens/image-upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: this.progressEvent,
        })
        .then((res) => {
          this.form.fingerprint_right = res.data.imageUrl;
          this.isUploading = false;
        })
        .catch((err) => {
          this.isUploading = false;
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },
    uploadSignature(signatureScan) {
      this.isUploading = true;
      this.$emit('input', signatureScan);
      this.uploadPercent = 0;

      let formData = new FormData();

      formData.append('image', signatureScan);

      axiosInstance
        .post(`${getAPIEndpoint()}/citizens/image-upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: this.progressEvent,
        })
        .then((res) => {
          this.form.signature_scan = res.data.imageUrl;
          this.isUploading = false;
        })
        .catch((err) => {
          this.isUploading = false;
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },
        cancel() {
      this.$emit('cancel');
    },
    clearFormDateOne(){
      this.form.form_date_one = '';
      this.formDateOneComponentKey += 1;
    },
    clearFormDate(){
      console.log('df');
      this.form.form_date = '';
      this.formDateComponentKey += 1;
    }
  },
};
</script>


<style scoped>
.modal-card {
  width: 60%;
}

.modal-card-title {
  font-weight: 800;
}

.container {
  width: 50px;
  margin: 0 80%;
}

.level .img {
  right: -112px;
  position: absolute;
  border-radius: 30px;
}
</style>


